import React from 'react';
import './Icons.css';

interface IconProps {
    onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    className?: string;
}

interface NotificationIconProps {
    numberOfUnreadNotifications: number;
}

export const ResearchAreasIcon = () => {
    return (
        <svg
            width='21'
            height='21'
            viewBox='0 0 21 21'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M2.08334 4.08333L2.08334 18.6667L16.6667 18.6667L16.6667 12.4167L18.75 12.4167L18.75 18.6667C18.75 19.8125 17.8125 20.75 16.6667 20.75L2.08334 20.75C0.937502 20.75 3.77372e-06 19.8125 3.72363e-06 18.6667L3.08617e-06 4.08333C3.03609e-06 2.9375 0.937501 2 2.08334 2L8.41667 2L8.41667 4.08333L2.08334 4.08333Z' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.7481 9.03098L19.3269 10.6207H19.3522L19.7232 11H19.8214L21 9.86207L19.8214 8.64828V8.58924L18.1773 6.93965C19.321 5.20003 19.1335 2.84186 17.6057 1.30873C17.3002 1.00229 16.9613 0.749124 16.6006 0.549704C15.9379 0.183863 15.2011 0 14.4606 0C13.3169 0 12.1821 0.439386 11.3066 1.30873C9.56447 3.05731 9.56447 5.89022 11.3066 7.62938C12.1733 8.49919 13.3169 8.93858 14.4606 8.93858C15.2868 8.93858 16.1132 8.70537 16.8356 8.2478L17.7481 9.03098ZM14.4606 7.15463C14.5484 7.15463 14.6355 7.15039 14.7216 7.1419C15.3375 7.08062 15.9069 6.80576 16.346 6.36544C16.7184 5.99818 16.9666 5.53947 17.0729 5.03926C17.112 4.85587 17.132 4.66682 17.132 4.474C17.132 3.75647 16.8462 3.08419 16.346 2.5821C15.8455 2.07105 15.1754 1.7929 14.4606 1.7929C13.7457 1.7929 13.0756 2.07105 12.5752 2.5821C12.3268 2.82725 12.1335 3.11294 12.001 3.42457C11.8618 3.75128 11.7892 4.10675 11.7892 4.474C11.7892 4.94828 11.9141 5.40275 12.1433 5.80112C12.2608 6.00572 12.4058 6.19524 12.5752 6.36544C12.6773 6.46963 12.7865 6.56439 12.9019 6.64877C13.0283 6.74165 13.1618 6.82227 13.301 6.89015C13.6572 7.06317 14.0515 7.15463 14.4606 7.15463Z'
            />
            <path d='M8.5 6H4V8H8.5V6Z' />
            <path d='M12 10H4V12H12V10Z' />
            <path d='M10 14H4V16H10V14Z' />
        </svg>
    );
};

export const CheckmarkIcon = () => {
    return (
        <svg
            width='23'
            height='23'
            viewBox='0 0 23 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx='11.0488' cy='11.2598' r='11' fill='white' />
            <path
                d='M11.0488 4.75977C6.88974 4.75977 3.54883 8.10067 3.54883 12.2598C3.54883 16.4189 6.88974 19.7598 11.0488 19.7598C15.2079 19.7598 18.5488 16.4189 18.5488 12.2598C18.5488 8.10067 15.2079 4.75977 11.0488 4.75977ZM10.0261 15.737L6.20794 11.9189L7.63974 10.487L9.95794 12.8052L14.3215 8.44158L15.7534 9.8734L10.0261 15.737Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const ValidIcon = () => {
    return (
        <svg
            data-testid={'valid-icon'}
            width='19'
            height='15'
            viewBox='0 0 19 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.56099 11.3531L2.39806 7.19014L0.980469 8.59775L6.56099 14.1783L18.5406 2.19862L17.133 0.791016L6.56099 11.3531Z'
                fill='#658F38'
            />
        </svg>
    );
};

export const InvalidIcon = () => {
    return (
        <svg
            data-testid={'invalid-icon'}
            width='16'
            height='15'
            viewBox='0 0 16 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.3359 1.65847L13.8664 0.188965L8.04053 6.01488L2.21462 0.188965L0.745117 1.65847L6.57103 7.48438L0.745117 13.3103L2.21462 14.7798L8.04053 8.95389L13.8664 14.7798L15.3359 13.3103L9.51004 7.48438L15.3359 1.65847Z'
                fill='#C12743'
            />
        </svg>
    );
};

export const AvatarIcon = () => {
    return (
        <svg
            width='65'
            height='65'
            viewBox='0 0 65 65'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx='32.0547' cy='32.4121' r='32' fill='#95AAC9' />
            <path
                d='M32.0542 17.8806C28.5677 17.8806 25.7437 20.7046 25.7437 24.1912C25.7437 27.6778 28.5677 30.5018 32.0542 30.5018C35.5408 30.5018 38.3648 27.6778 38.3648 24.1912C38.3648 20.7046 35.5408 17.8806 32.0542 17.8806ZM32.0542 33.657C27.8419 33.657 19.4331 35.7711 19.4331 39.9676V43.1229H44.6754V39.9676C44.6754 35.7711 36.2665 33.657 32.0542 33.657Z'
                fill='white'
            />
        </svg>
    );
};

export const ProjectHandInConfirmationIcon = () => {
    return (
        <svg
            width='24'
            height='35'
            viewBox='0 0 24 35'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14.1213 10.5883C14.6839 10.0257 15 9.26267 15 8.46702C15 7.67137 14.6839 6.90831 14.1213 6.3457C13.5587 5.78309 12.7956 5.46702 12 5.46702C11.2044 5.46702 10.4413 5.78309 9.87868 6.3457C9.31607 6.90831 9 7.67137 9 8.46702C9 9.26267 9.31607 10.0257 9.87868 10.5883C10.4413 11.151 11.2044 11.467 12 11.467C12.7956 11.467 13.5587 11.151 14.1213 10.5883Z'
                stroke='#B1C2D9'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6 15.9067C7.8158 14.8804 9.86674 14.3426 11.9525 14.3457C14.1158 14.3457 16.1467 14.9125 17.905 15.9067'
                stroke='#B1C2D9'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const ProjectsIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M2.32129 4H0.321289V18C0.321289 19.1 1.22129 20 2.32129 20H16.3213V18H2.32129V4ZM18.3213 0H6.32129C5.22129 0 4.32129 0.9 4.32129 2V14C4.32129 15.1 5.22129 16 6.32129 16H18.3213C19.4213 16 20.3213 15.1 20.3213 14V2C20.3213 0.9 19.4213 0 18.3213 0ZM18.3213 14H6.32129V2H18.3213V14ZM8.32129 7H16.3213V9H8.32129V7ZM8.32129 10H12.3213V12H8.32129V10ZM8.32129 4H16.3213V6H8.32129V4Z' />
        </svg>
    );
};

export const CloseIcon = () => {
    return (
        <svg
            width='41'
            height='41'
            viewBox='0 0 41 41'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='-6.58579'
                y='20.2842'
                width='38'
                height='38'
                rx='19'
                transform='rotate(-45 -6.58579 20.2842)'
                fill='white'
                stroke='#E3EBF6'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M27.6836 14.8778L26.2736 13.4678L20.6836 19.0578L15.0936 13.4678L13.6836 14.8778L19.2736 20.4678L13.6836 26.0578L15.0936 27.4678L20.6836 21.8778L26.2736 27.4678L27.6836 26.0578L22.0936 20.4678L27.6836 14.8778Z'
                fill='black'
            />
        </svg>
    );
};

export const CloseModalIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='15'
            fill='none'
        >
            <path
                fill='#000'
                d='m14.731 1.499-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59 5.59-5.59Z'
            />
        </svg>
    );
};

export const PlusIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-plus'
            viewBox='0 0 16 16'
        >
            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
        </svg>
    );
};

export const BackIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='32'
            height='9'
            viewBox='0 0 32 9'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.99 3.5H31.5V5.5H3.99V8.5L0 4.5L3.99 0.5V3.5Z'
                fill='#95AAC9'
            />
        </svg>
    );
};
export const NextGradingTrendIcon = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx='19.8975' cy='20' r='19.5' fill='white' />
            <path
                d='M14.567 22.7537L20.7196 17.5068L19.1977 15.7221C18.8151 15.2735 19.1664 14.595 19.7391 14.6405L24.893 15.05C25.2624 15.0794 25.526 15.3884 25.4966 15.7579L25.0871 20.9118C25.0501 21.4944 24.3247 21.7342 23.9421 21.2855L22.4201 19.5009L16.2675 24.7477C15.7191 25.2154 14.8879 25.1493 14.4202 24.601C13.9526 24.0526 14.0186 23.2213 14.567 22.7537Z'
                fill='#81A94E'
            />
        </svg>
    );
};

export const NextInvoiceIcon = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle opacity='0.4' cx='20' cy='20' r='20' fill='#D3EAB6' />
            <path
                d='M14.9483 22.1614L21.101 16.9145L19.579 15.1299C19.1964 14.6812 19.5478 14.0027 20.1204 14.0482L25.2743 14.4577C25.6438 14.4871 25.9073 14.7962 25.878 15.1656L25.4685 20.3195C25.4315 20.9021 24.706 21.1419 24.3234 20.6933L22.8015 18.9086L16.6488 24.1554C16.1005 24.6231 15.2692 24.557 14.8016 24.0087C14.3339 23.4603 14.4 22.629 14.9483 22.1614Z'
                fill='white'
            />
        </svg>
    );
};

export const PencilSquareIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='20'
            height='19'
            viewBox='0 0 20 19'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M14.5 2.5V7.49448L16.949 5V2C16.949 0.899994 16.0517 0 14.955 0H1.994C0.897326 0 0 0.899994 0 2V16C0 17.1 0.897326 18 1.994 18H6.48051C6.22128 17.38 6.05181 16.21 6.00197 15.5H2.5V2.5H14.5Z' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.2257 7.49448L19.507 8.7796C20.1643 9.42773 20.1643 10.4893 19.507 11.1487L12.6162 18.0602H8.97301V14.406L15.8638 7.49448C16.51 6.83517 17.5684 6.83517 18.2257 7.49448ZM10.6999 16.328H11.8475L16.6882 11.4727L15.5407 10.3217L10.6999 15.177V16.328Z'
            />
        </svg>
    );
};

export const PaperClipIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='15'
            height='16'
            viewBox='0 0 15 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.0922 7.19661L6.87461 13.4142C5.67974 14.6091 3.74416 14.6091 2.5493 13.4142C1.35443 12.2194 1.35443 10.2838 2.5493 9.08893L9.3076 2.33063C10.0537 1.58451 11.2648 1.58451 12.0109 2.33063C12.757 3.07675 12.757 4.28783 12.0109 5.03395L6.33395 10.7109C6.03658 11.0083 5.54998 11.0083 5.25262 10.7109C4.95525 10.4136 4.95525 9.92696 5.25262 9.62959L10.3889 4.49329L9.57793 3.68229L4.44162 8.8186C3.6955 9.56471 3.6955 10.7758 4.44162 11.5219C5.18774 12.268 6.39882 12.268 7.14494 11.5219L12.8219 5.84495C14.0168 4.65008 14.0168 2.7145 12.8219 1.51963C11.627 0.324766 9.69147 0.324766 8.4966 1.51963L1.7383 8.27793C0.0946821 9.92155 0.0946821 12.5816 1.7383 14.2252C3.38192 15.8689 6.04199 15.8689 7.68561 14.2252L13.9032 8.0076L13.0922 7.19661Z'
                fill='#1F2756'
                stroke='#1F2756'
                strokeWidth='0.2'
            />
        </svg>
    );
};

export const XIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            data-testid='XIcon'
            width='16'
            height='16'
            viewBox='0 0 10 11'
            fill='currentColor'
            className='bi bi-x'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.42 1.84704L8.47127 0.898315L4.71 4.65959L0.948729 0.898315L0 1.84704L3.76127 5.60832L0 9.36959L0.948729 10.3183L4.71 6.55704L8.47127 10.3183L9.42 9.36959L5.65873 5.60832L9.42 1.84704Z'
                fill='#6E84A3'
            />
        </svg>
    );
};

export const ScoringRubric = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='102'
            height='103'
            viewBox='0 0 102 103'
            fill='none'
        >
            <path
                d='M68.8966 61.7009C68.6966 61.7009 68.5966 61.6009 68.3966 61.5009C68.0966 61.2009 67.9966 60.8009 68.2966 60.4009L71.6966 56.3009C71.9966 56.0009 72.3966 55.9009 72.7966 56.2009C73.0966 56.5009 73.1966 56.9009 72.8966 57.3009L69.4966 61.4009C69.2966 61.6009 69.0966 61.7009 68.8966 61.7009Z'
                fill='#030047'
            />
            <path
                d='M100.497 99.0009C100.297 99.0009 100.097 98.9009 99.8967 98.7009L92.8967 90.3009C92.5967 90.0009 92.6967 89.5009 92.9967 89.2009C93.2967 88.9009 93.7967 89.0009 94.0967 89.3009L101.097 97.7009C101.397 98.0009 101.297 98.5009 100.997 98.8009C100.797 99.0009 100.697 99.0009 100.497 99.0009Z'
                fill='#030047'
            />
            <path
                d='M8.18448 27.201C8.08448 27.201 8.08447 27.201 7.98447 27.201L1.5845 25.701C1.1845 25.601 0.884468 25.201 0.984468 24.801C1.08447 24.401 1.48449 24.101 1.88449 24.201L8.28446 25.701C8.68446 25.801 8.98449 26.201 8.88449 26.601C8.78449 27.001 8.48448 27.201 8.18448 27.201Z'
                fill='#030047'
            />
            <path
                d='M81.4965 70.1011H50.1965V101.401H81.4965V70.1011Z'
                fill='white'
            />
            <path
                d='M82.1967 102.101H49.3967V69.301H82.1967V102.101ZM50.8967 100.601H80.6967V70.801H50.8967V100.601Z'
                fill='#030047'
            />
            <path
                d='M73.0777 49.301H14.2776V0.801025H73.0777V49.301ZM15.9749 47.801H71.1379V2.30103H15.9749V47.801Z'
                fill='#030047'
            />
            <path
                d='M49.3265 12.9913H27.2541C26.8192 12.9913 26.3843 12.6913 26.3843 12.1913C26.3843 11.6913 26.7105 11.3914 27.2541 11.3914H49.3265C49.7614 11.3914 50.1963 11.6913 50.1963 12.1913C50.1963 12.6913 49.7614 12.9913 49.3265 12.9913Z'
                fill='#79A342'
            />
            <path
                d='M49.3265 19.3913H27.2541C26.8192 19.3913 26.3843 19.0913 26.3843 18.5913C26.3843 18.0913 26.7105 17.7913 27.2541 17.7913H49.3265C49.7614 17.7913 50.1963 18.0913 50.1963 18.5913C50.1963 19.0913 49.7614 19.3913 49.3265 19.3913Z'
                fill='#79A342'
            />
            <path
                d='M49.3265 32.551H27.2541C26.8192 32.551 26.3843 32.251 26.3843 31.751C26.3843 31.251 26.7105 30.9509 27.2541 30.9509H49.3265C49.7614 30.9509 50.1963 31.251 50.1963 31.751C50.1963 32.251 49.7614 32.551 49.3265 32.551Z'
                fill='#79A342'
            />
            <path
                d='M74.4263 80.4008H57.8979C57.5723 80.4008 57.2466 80.1008 57.2466 79.6008C57.2466 79.1008 57.4908 78.8008 57.8979 78.8008H74.4263C74.752 78.8008 75.0776 79.1008 75.0776 79.6008C75.0776 80.1008 74.752 80.4008 74.4263 80.4008Z'
                fill='#030047'
            />
            <path
                d='M49.3268 25.6913H44.8689C44.4339 25.6913 43.999 25.3913 43.999 24.8913C43.999 24.3913 44.3252 24.0913 44.8689 24.0913H49.3268C49.7617 24.0913 50.1966 24.3913 50.1966 24.8913C50.1966 25.3913 49.7617 25.6913 49.3268 25.6913Z'
                fill='#79A342'
            />
            <path
                d='M49.3268 38.851H44.8689C44.4339 38.851 43.999 38.551 43.999 38.051C43.999 37.551 44.3252 37.251 44.8689 37.251H49.3268C49.7617 37.251 50.1966 37.551 50.1966 38.051C50.1966 38.551 49.7617 38.851 49.3268 38.851Z'
                fill='#79A342'
            />
            <path
                d='M40.7368 25.6913H27.2541C26.8192 25.6913 26.3843 25.3913 26.3843 24.8913C26.3843 24.3913 26.7105 24.0913 27.2541 24.0913H40.7368C41.1717 24.0913 41.6066 24.3913 41.6066 24.8913C41.6066 25.3913 41.1717 25.6913 40.7368 25.6913Z'
                fill='#79A342'
            />
            <path
                d='M40.7368 38.851H27.2541C26.8192 38.851 26.3843 38.551 26.3843 38.051C26.3843 37.551 26.7105 37.251 27.2541 37.251H40.7368C41.1717 37.251 41.6066 37.551 41.6066 38.051C41.6066 38.551 41.1717 38.851 40.7368 38.851Z'
                fill='#79A342'
            />
            <path
                d='M67.9941 86.7008H57.8979C57.5723 86.7008 57.2466 86.4008 57.2466 85.9008C57.2466 85.4008 57.4908 85.1008 57.8979 85.1008H67.9941C68.3198 85.1008 68.6455 85.4008 68.6455 85.9008C68.6455 86.4008 68.3198 86.7008 67.9941 86.7008Z'
                fill='#030047'
            />
            <path
                d='M37.3344 70.2141H4.93433V90.2141H37.3344V70.2141Z'
                fill='white'
            />
            <path
                d='M38.1344 91.0142H4.23438V69.5142H38.1344V91.0142ZM5.73438 89.5142H36.6344V71.0142H5.73438V89.5142Z'
                fill='#030047'
            />
            <path
                d='M30.4344 81.0141H11.5344C11.1344 81.0141 10.7344 80.7141 10.7344 80.2141C10.7344 79.7141 11.0344 79.4141 11.5344 79.4141H30.4344C30.8344 79.4141 31.2344 79.7141 31.2344 80.2141C31.2344 80.7141 30.8344 81.0141 30.4344 81.0141Z'
                fill='#030047'
            />
        </svg>
    );
};

export const NonScoringRubric = () => {
    return (
        <svg
            width='177'
            height='108'
            viewBox='0 0 177 108'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M103.365 57.624C103.94 52.5476 100.349 51.012 100.349 51.012C100.566 48.0048 96.483 46.3839 96.483 46.3839C98.638 40.9725 100.736 39.4077 100.14 37.579C99.303 34.7952 96.631 36.159 92.899 41.2972C92.393 40.7021 91.506 40.5484 89.725 41.4576C85.716 43.5033 82.992 50.44 82.625 59.003C82.625 59.003 82.625 59.0029 82.607 59.1015C82.192 59.74 81.794 60.28 81.413 60.7214L91.693 80.4665C91.693 80.4665 95.072 79.1238 96.936 73.0529C98.026 69.6896 99.488 64.767 100.425 62.2905C103.312 63.1969 103.135 60.1214 103.365 57.624Z'
                fill='white'
            />
            <path
                d='M91.424 81.4347L80.625 60.5848L80.89 60.2248C81.271 59.7834 81.652 59.342 81.952 58.7849C82.255 50.0078 85.211 42.9082 89.433 40.7981C90.868 40.1333 91.921 39.9099 92.774 40.2606C95.41 36.7594 97.41 35.1776 98.986 35.4508C99.577 35.5532 100.413 36.0024 100.782 37.3858C101.151 38.7692 100.552 39.8833 99.538 41.6358C98.939 42.7499 98.092 44.1254 97.339 46.1263C98.552 46.7424 100.926 48.2702 101.009 50.7203C102.007 51.4008 104.51 53.3569 103.939 57.8249C103.87 58.2191 103.918 58.5317 103.849 58.9258C103.658 60.6179 103.564 62.3271 102.425 63.0432C101.963 63.369 101.453 63.3821 100.862 63.2797C100.127 65.182 99.22 68.0697 98.481 70.5803C98.211 71.5486 97.844 72.4997 97.608 73.2709C95.595 79.6203 92.083 81.1431 91.869 81.2074L91.424 81.4347ZM82.416 60.7936L92.078 79.4168C93.003 78.7652 95.053 76.8877 96.362 72.8518C96.614 71.9821 96.866 71.1124 97.234 70.1613C98.14 67.2736 99.132 63.8933 99.949 62.1066L100.266 61.451L100.938 61.6691C101.217 61.8188 101.709 61.9042 101.941 61.7413C102.403 61.4155 102.561 59.9204 102.667 58.7209C102.735 58.3268 102.705 57.9156 102.756 57.62C103.311 53.2505 100.311 51.8174 100.213 51.8003L99.737 51.6163L99.724 51.1066C99.937 48.7077 96.329 47.2706 96.346 47.1721L95.691 46.8555L96.007 46.1999C96.927 43.822 97.924 42.168 98.557 40.8569C99.438 39.2843 99.871 38.5472 99.596 37.7892C99.386 37.2453 99.24 36.9156 98.944 36.8644C98.649 36.8132 97.218 36.8697 93.734 41.7464L93.186 42.5649L92.616 41.7557C92.192 41.2762 90.971 41.8766 90.428 42.0868C86.749 43.9867 84.059 50.7263 83.743 58.9937L83.708 59.1908L83.576 59.3708C83.079 59.8936 82.698 60.3351 82.416 60.7936Z'
                fill='#030047'
            />
            <path
                d='M93.725 40.6286L77.176 52.3755C75.211 53.7603 77.41 56.8816 80.069 55.0081L89.647 48.3457C90.503 45.7536 91.555 43.1957 93.725 40.6286Z'
                fill='#030047'
            />
            <path
                d='M102.645 36.5923C102.319 36.1299 100.97 36.3021 99.801 36.6069C100.564 38.0585 99.846 39.8623 99.178 41.3705L100.45 40.4745C101.491 39.7414 103.215 37.4016 102.645 36.5923Z'
                fill='#030047'
            />
            <path
                d='M95.306 47.9054L94.275 49.7565C93.975 50.3135 94.811 50.7628 95.209 50.2228C95.525 49.5672 95.923 49.0273 96.24 48.3717C96.539 47.8147 95.588 47.4469 95.306 47.9054Z'
                fill='#030047'
            />
            <path
                d='M102.542 57.6843C102.546 57.0761 101.527 57.1024 101.506 57.8092C101.468 58.6145 101.233 59.3857 100.8 60.1227C100.501 60.6798 101.336 61.129 101.734 60.5891C102.299 59.6721 102.47 58.6867 102.542 57.6843Z'
                fill='#030047'
            />
            <path
                d='M92.586 41.3446C91.011 43.4059 89.081 46.9281 88.243 49.4216C88.042 49.9958 88.976 50.4621 89.177 49.888C89.998 47.493 91.812 44.0522 93.37 42.0894C93.785 41.4509 92.984 40.8046 92.586 41.3446Z'
                fill='#030047'
            />
            <path
                d='M99.129 51.6125C98.863 51.9725 98.68 52.448 98.414 52.808C98.115 53.365 98.95 53.8143 99.348 53.2743C99.614 52.9144 99.798 52.4388 100.063 52.0788C100.362 51.5218 99.527 51.0725 99.129 51.6125Z'
                fill='#030047'
            />
            <path
                d='M144.857 46.6757H113.057C112.657 46.6757 112.257 46.3757 112.257 45.8757C112.257 45.3757 112.557 45.0757 113.057 45.0757H143.357V4.37573H100.757V24.6757C100.757 25.0757 100.457 25.4757 99.957 25.4757C99.457 25.4757 99.157 25.1757 99.157 24.6757V2.87573H144.857V46.6757Z'
                fill='#030047'
            />
            <path
                d='M147.057 0.675537H140.957V6.77551H147.057V0.675537Z'
                fill='#030047'
            />
            <path
                d='M144.057 60.0752C143.857 60.0752 143.757 59.9752 143.557 59.8752C143.257 59.5752 143.157 59.1751 143.457 58.7751L146.857 54.6752C147.157 54.3752 147.557 54.2752 147.957 54.5752C148.257 54.8752 148.357 55.2752 148.057 55.6752L144.657 59.7751C144.457 59.9751 144.257 60.0752 144.057 60.0752Z'
                fill='#030047'
            />
            <path
                d='M175.657 97.3752C175.457 97.3752 175.257 97.2752 175.057 97.0752L168.057 88.6752C167.757 88.3752 167.857 87.8752 168.157 87.5752C168.457 87.2752 168.957 87.3752 169.257 87.6752L176.257 96.0752C176.557 96.3752 176.457 96.8752 176.157 97.1752C175.957 97.3752 175.857 97.3752 175.657 97.3752Z'
                fill='#030047'
            />
            <path
                d='M90.857 25.5753C90.757 25.5753 90.757 25.5753 90.657 25.5753L84.257 24.0753C83.857 23.9753 83.557 23.5753 83.657 23.1753C83.757 22.7753 84.157 22.4753 84.557 22.5753L90.957 24.0753C91.357 24.1753 91.657 24.5753 91.557 24.9753C91.457 25.3753 91.157 25.5753 90.857 25.5753Z'
                fill='#030047'
            />
            <path
                d='M156.657 68.4753H125.357V99.7753H156.657V68.4753Z'
                fill='white'
            />
            <path
                d='M157.357 100.475H124.557V67.6753H157.357V100.475ZM126.057 98.9753H155.857V69.1753H126.057V98.9753Z'
                fill='#030047'
            />
            <path
                d='M147.457 91.3753C147.257 91.3753 147.057 91.2753 146.957 91.1753L133.957 78.1753C133.657 77.8753 133.657 77.3753 133.957 77.0753C134.257 76.7753 134.757 76.7753 135.057 77.0753L147.957 89.9753C148.257 90.2753 148.257 90.7753 147.957 91.0753C147.857 91.2753 147.657 91.3753 147.457 91.3753Z'
                fill='#030047'
            />
            <path
                d='M134.457 91.3752C134.257 91.3752 134.057 91.2752 133.957 91.1752C133.657 90.8752 133.657 90.3752 133.957 90.0752L146.857 77.1752C147.157 76.8752 147.657 76.8752 147.957 77.1752C148.257 77.4752 148.257 77.9752 147.957 78.2752L135.057 91.1752C134.857 91.2752 134.657 91.3752 134.457 91.3752Z'
                fill='#030047'
            />
            <path
                d='M104.205 59.1904C104.781 54.1141 101.19 52.5785 101.19 52.5785C101.407 49.5713 97.324 47.9504 97.324 47.9504C99.479 42.539 101.577 40.9742 100.981 39.1454C100.062 36.246 97.257 37.7898 93.44 43.4207C93.025 44.0592 92.61 44.6977 92.195 45.3362C91.59 44.724 90.686 44.6689 89.265 45.8434C85.908 48.814 83.799 52.2035 83.547 60.685C83.132 61.3235 82.734 61.8635 82.237 62.3864L92.517 82.1316C92.517 82.1316 95.896 80.7887 97.76 74.7179C98.85 71.3546 100.312 66.432 101.248 63.9555C104.038 64.8448 103.86 61.7693 104.205 59.1904Z'
                fill='white'
            />
            <path
                d='M92.265 83.0011L81.35 62.2326L81.616 61.8726C81.997 61.4312 82.378 60.9898 82.677 60.4327C82.946 51.8527 85.073 48.3646 88.661 45.2312C89.984 44.0395 91.102 44.0303 91.774 44.2483C92.057 43.7898 92.339 43.3313 92.604 42.9713C95.575 38.716 97.839 36.7742 99.63 36.983C100.221 37.0855 101.057 37.5347 101.525 38.9351C101.894 40.3185 101.295 41.4326 100.281 43.1852C99.682 44.2992 98.834 45.6748 98.082 47.6756C99.294 48.2917 101.668 49.8195 101.751 52.2697C102.75 52.9501 105.252 54.9062 104.681 59.3743C104.613 59.7684 104.66 60.081 104.592 60.4752C104.4 62.1673 104.307 63.8764 103.168 64.5925C102.705 64.9183 102.196 64.9315 101.604 64.829C100.869 66.7314 99.962 69.619 99.223 72.1296C98.954 73.0979 98.586 74.049 98.334 74.9187C96.32 81.2681 92.808 82.7909 92.594 82.8553L92.265 83.0011ZM83.158 62.3429L92.82 80.9661C93.745 80.3145 95.796 78.437 97.104 74.4012C97.356 73.5314 97.608 72.6618 97.976 71.7106C98.883 68.8229 99.874 65.4426 100.691 63.6559L101.008 63.0003L101.681 63.2184C101.959 63.3681 102.452 63.4535 102.683 63.2906C103.145 62.9647 103.303 61.4697 103.409 60.2703C103.478 59.8761 103.447 59.465 103.499 59.1694C104.053 54.7998 101.054 53.3666 100.955 53.3495L100.479 53.1657L100.466 52.6559C100.679 50.257 97.071 48.82 97.088 48.7214L96.433 48.4048L96.651 47.7322C97.57 45.3542 98.568 43.7002 99.201 42.389C100.082 40.8165 100.514 40.0795 100.24 39.3215C100.03 38.7776 99.884 38.4478 99.588 38.3966C99.293 38.3453 97.763 38.3848 93.997 43.7201C93.582 44.3586 93.167 44.9971 92.752 45.6356L92.319 46.3726L91.617 45.7434C91.437 45.6107 91.012 45.1312 89.706 46.2243C86.466 49.1133 84.488 52.3229 84.288 60.5089L84.254 60.7059L84.121 60.8859C83.804 61.5415 83.522 62 83.158 62.3429Z'
                fill='#030047'
            />
            <path
                d='M96.382 48.7003L95.35 50.5514C95.051 51.1085 95.887 51.5577 96.285 51.0177C96.601 50.3622 96.999 49.8222 97.316 49.1666C97.632 48.5111 96.681 48.1433 96.382 48.7003Z'
                fill='#030047'
            />
            <path
                d='M103.267 59.3323C103.271 58.724 102.252 58.7504 102.231 59.4572C102.193 60.2625 101.958 61.0336 101.526 61.7707C101.226 62.3277 102.062 62.777 102.46 62.237C103.042 61.2215 103.294 60.3517 103.267 59.3323Z'
                fill='#030047'
            />
            <path
                d='M100.496 53.0671C100.231 53.427 100.047 53.9026 99.782 54.2626C99.482 54.8196 100.318 55.2689 100.716 54.7289C100.981 54.3689 101.165 53.8934 101.431 53.5334C101.73 52.9764 100.796 52.51 100.496 53.0671Z'
                fill='#030047'
            />
            <path
                d='M0.737976 47.6114C0.606934 47.518 0.475891 47.4243 0.34491 47.3303L0.345032 85.5123C0.345032 85.5123 21.27 104.94 48.8937 107.486C72.814 109.627 92.684 88.1887 97.61 76.7785C96.1263 68.4356 87.8293 60.4261 82.174 54.9667L82.068 54.8644C73.898 65.9481 69.2317 69.7383 61.6623 70.5492C58.7492 70.8858 54.9227 70.6794 50.434 69.8954C45.2808 67.6782 39.1604 64.6006 32.1085 61.0545C23.0092 56.4789 12.3589 51.1234 0.234314 45.8303L0.737976 47.6114Z'
                fill='#030047'
            />
            <path
                d='M131.269 33.5154C131.386 33.8669 131.459 34.1453 131.488 34.3503C131.518 34.5554 131.479 34.7117 131.371 34.8191C131.264 34.9167 131.073 34.9753 130.8 34.9949C130.526 35.0242 130.15 35.0388 129.672 35.0388C129.174 35.0388 128.783 35.0291 128.5 35.0095C128.227 34.9998 128.017 34.9753 127.87 34.9363C127.724 34.8875 127.621 34.824 127.562 34.7458C127.504 34.6677 127.455 34.5652 127.416 34.4382L126.142 30.6296H119.022L117.821 34.3357C117.782 34.4724 117.729 34.5896 117.66 34.6873C117.602 34.7751 117.499 34.8484 117.353 34.907C117.216 34.9558 117.016 34.99 116.752 35.0095C116.498 35.0291 116.161 35.0388 115.741 35.0388C115.292 35.0388 114.94 35.0242 114.687 34.9949C114.433 34.9656 114.257 34.8972 114.159 34.7898C114.062 34.6726 114.027 34.5115 114.057 34.3064C114.086 34.1013 114.159 33.8279 114.276 33.4861L120.121 16.6697C120.18 16.5037 120.248 16.3718 120.326 16.2742C120.404 16.1667 120.526 16.0886 120.692 16.0398C120.868 15.9812 121.107 15.947 121.41 15.9373C121.713 15.9177 122.113 15.908 122.611 15.908C123.188 15.908 123.646 15.9177 123.988 15.9373C124.33 15.947 124.594 15.9812 124.779 16.0398C124.975 16.0886 125.111 16.1667 125.189 16.2742C125.277 16.3816 125.351 16.5281 125.409 16.7136L131.269 33.5154ZM122.567 19.614H122.553L119.872 27.6707H125.248L122.567 19.614Z'
                fill='#79A342'
            />
        </svg>
    );
};
export const ArrowRightIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='6'
            height='9'
            viewBox='0 0 6 9'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.06763 4.13816L4.77856 3.81595L1.63212 0.669396L1.56287 0.61154C1.368 0.476544 1.09858 0.49583 0.925011 0.669396L0.867156 0.738644C0.732159 0.933512 0.751445 1.20294 0.925011 1.3765L4.07156 4.52295L0.925011 7.6694C0.729749 7.86466 0.729749 8.18124 0.925011 8.3765C1.12027 8.57176 1.43686 8.57176 1.63212 8.3765L4.77856 5.22995L5.06763 4.90853V4.13816Z'
                fill='currentColor'
            />
        </svg>
    );
};

export const CalendarIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='1.5em'
            height='1.5em'
            viewBox='0 0 18 20'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M13 0V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2H15V0H13ZM16 18H2V7H16V18Z' />
        </svg>
    );
};

export const EyeIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='20'
            height='24'
            viewBox='0 0 20 24'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10 9.575C11.84 9.575 13.48 10.583 14.34 12.2C13.48 13.817 11.84 14.825 10 14.825C8.16 14.825 6.52 13.817 5.66 12.2C6.52 10.583 8.16 9.575 10 9.575ZM10 8C7.27 8 4.94 9.743 4 12.2C4.94 14.657 7.27 16.4 10 16.4C12.73 16.4 15.06 14.657 16 12.2C15.06 9.743 12.73 8 10 8ZM10 13.775C9.17 13.775 8.5 13.0715 8.5 12.2C8.5 11.3285 9.17 10.625 10 10.625C10.83 10.625 11.5 11.3285 11.5 12.2C11.5 13.0715 10.83 13.775 10 13.775Z'
                stroke='#31417A'
                strokeWidth='0.3'
            />
            <path d='M18 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM18 18H2V6H18V18ZM2 0H18V2H2V0ZM2 22H18V24H2V22Z' />
        </svg>
    );
};

export const ClockIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z' />
        </svg>
    );
};

export const ReverseClockIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='22'
            height='19'
            viewBox='0 0 22 19'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M12.5714 0C7.36476 0 3.14286 4.25389 3.14286 9.5H0L4.07524 13.6061L4.14857 13.7539L8.38095 9.5H5.2381C5.2381 5.415 8.51714 2.11111 12.5714 2.11111C16.6257 2.11111 19.9048 5.415 19.9048 9.5C19.9048 13.585 16.6257 16.8889 12.5714 16.8889C10.5495 16.8889 8.71619 16.055 7.39619 14.7144L5.90857 16.2133C7.61619 17.9339 9.96286 19 12.5714 19C17.7781 19 22 14.7461 22 9.5C22 4.25389 17.7781 0 12.5714 0ZM11.5238 5.27778V10.5556L15.9762 13.2156L16.7829 11.8644L13.0952 9.65833V5.27778H11.5238Z' />
        </svg>
    );
};

export const CheckboxCircle = () => {
    return (
        <svg
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.6274 0.920654C5.77116 0.920654 0.206665 6.48515 0.206665 13.3414C0.206665 20.1977 5.77116 25.7622 12.6274 25.7622C19.4837 25.7622 25.0482 20.1977 25.0482 13.3414C25.0482 6.48515 19.4837 0.920654 12.6274 0.920654ZM10.1433 19.5518L3.93294 13.3414L5.68426 11.5901L10.1433 16.0367L19.5707 6.60936L21.322 8.3731L10.1433 19.5518Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const ExternalSupervisor = () => {
    return (
        <svg
            data-testid={'external-type-icon'}
            width='20'
            height='18'
            viewBox='0 0 20 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.0664 4.56567C12.0664 6.77661 10.2764 8.56567 8.06641 8.56567C5.85645 8.56567 4.06641 6.77661 4.06641 4.56567C4.06641 2.35474 5.85645 0.565674 8.06641 0.565674C10.2764 0.565674 12.0664 2.35474 12.0664 4.56567ZM10.0664 4.56567C10.0664 3.46606 9.16602 2.56567 8.06641 2.56567C7.30176 2.56567 6.63379 2.99927 6.29785 3.63403C6.15039 3.91333 6.06641 4.22974 6.06641 4.56567C6.06641 5.66528 6.9668 6.56567 8.06641 6.56567C9.16602 6.56567 10.0664 5.66528 10.0664 4.56567Z'
                fill='#B1C2D9'
            />
            <path
                d='M7.02637 12.6262C4.63672 12.886 2.2666 13.9348 2.06641 14.5657H7.06641L9.06641 16.5657H0.0664062V14.5657C0.0664062 11.9055 5.39648 10.5657 8.06641 10.5657C8.38672 10.5657 8.67676 10.5852 9.06641 10.6262L7.02637 12.6262Z'
                fill='#B1C2D9'
            />
            <path
                d='M19.0664 8.97583H12.3242V10.9973H15.5947L10.9756 15.6965L12.3379 17.0657L17.0439 12.5012V15.718H19.0664V8.97583Z'
                fill='#B1C2D9'
            />
        </svg>
    );
};

export const InternalSupervisor = () => {
    return (
        <svg
            data-testid={'internal-type-icon'}
            width='21'
            height='17'
            viewBox='0 0 21 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.9883 4.56567C12.9883 6.77661 11.1982 8.56567 8.98828 8.56567C6.77832 8.56567 4.98828 6.77661 4.98828 4.56567C4.98828 2.35474 6.77832 0.565674 8.98828 0.565674C11.1982 0.565674 12.9883 2.35474 12.9883 4.56567ZM10.9883 4.56567C10.9883 3.46606 10.0879 2.56567 8.98828 2.56567C8.22363 2.56567 7.55566 2.99927 7.21973 3.63403C7.07227 3.91333 6.98828 4.22974 6.98828 4.56567C6.98828 5.66528 7.88867 6.56567 8.98828 6.56567C10.0879 6.56567 10.9883 5.66528 10.9883 4.56567Z'
                fill='#B1C2D9'
            />
            <path
                d='M7.94824 12.6262C5.55859 12.886 3.18848 13.9348 2.98828 14.5657H9.98828V16.5657H0.988281V14.5657C0.988281 11.9055 6.31836 10.5657 8.98828 10.5657C9.30859 10.5657 9.59863 10.5852 9.98828 10.6262L7.94824 12.6262Z'
                fill='#B1C2D9'
            />
            <path
                d='M12.6448 9.22241H19.0499V11.1428H15.9429L20.3311 15.6071L19.0369 16.9078L14.5661 12.5715V15.6275H12.6448V9.22241Z'
                fill='#B1C2D9'
            />
        </svg>
    );
};

export const AlertInfoIcon = () => {
    return (
        <svg
            width='19'
            height='19'
            viewBox='0 0 19 19'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
            className={'alert-icon'}
        >
            <path
                d='M8.39453 4.68562H10.1445V6.50562H8.39453V4.68562ZM8.39453 8.32562H10.1445V13.7856H8.39453V8.32562ZM9.26953 0.13562C4.43953 0.13562 0.519531 4.21242 0.519531 9.23562C0.519531 14.2588 4.43953 18.3356 9.26953 18.3356C14.0995 18.3356 18.0195 14.2588 18.0195 9.23562C18.0195 4.21242 14.0995 0.13562 9.26953 0.13562ZM9.26953 16.5156C5.41078 16.5156 2.26953 13.2487 2.26953 9.23562C2.26953 5.22252 5.41078 1.95562 9.26953 1.95562C13.1283 1.95562 16.2695 5.22252 16.2695 9.23562C16.2695 13.2487 13.1283 16.5156 9.26953 16.5156Z'
                fill='currentColor'
            />
        </svg>
    );
};

export const AlertWarningIcon = () => {
    return (
        <svg
            width='18'
            height='19'
            viewBox='0 0 18 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={'alert-icon'}
        >
            <path
                d='M7.96484 13.7795H9.71484V12.0295H7.96484V13.7795ZM7.96484 10.2795H9.71484V5.02954H7.96484V10.2795ZM8.83984 18.1545C4.00984 18.1545 0.0898438 14.2345 0.0898438 9.40454C0.0898438 4.57454 4.00984 0.654543 8.83984 0.654543C13.6698 0.654543 17.5898 4.57454 17.5898 9.40454C17.5898 14.2345 13.6698 18.1545 8.83984 18.1545ZM8.83984 2.40454C4.98109 2.40454 1.83984 5.54579 1.83984 9.40454C1.83984 13.2633 4.98109 16.4045 8.83984 16.4045C12.6986 16.4045 15.8398 13.2633 15.8398 9.40454C15.8398 5.54579 12.6986 2.40454 8.83984 2.40454Z'
                fill='#C12743'
            />
        </svg>
    );
};

export const AlertSuccessIcon = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={'alert-icon'}
        >
            <path
                d='M4.33966 9.59526L7.66289 12.9185L13.6447 6.93666L12.7076 5.99287L7.66289 11.0375L5.27681 8.6581L4.33966 9.59526Z'
                fill='#79A342'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.242188 9.22655C0.242188 4.39656 4.16219 0.476562 8.99219 0.476562C13.8222 0.476562 17.7422 4.39656 17.7422 9.22655C17.7422 14.0566 13.8222 17.9765 8.99219 17.9765C4.16219 17.9765 0.242188 14.0566 0.242188 9.22655ZM1.99219 9.22655C1.99219 13.0853 5.13344 16.2265 8.99219 16.2265C12.8509 16.2265 15.9922 13.0853 15.9922 9.22655C15.9922 5.36781 12.8509 2.22656 8.99219 2.22656C5.13344 2.22656 1.99219 5.36781 1.99219 9.22655Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const GearIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M17.1593 10.98C17.1993 10.66 17.2293 10.34 17.2293 10C17.2293 9.66 17.1993 9.34 17.1593 9.02L19.2693 7.37C19.4593 7.22 19.5093 6.95 19.3893 6.73L17.3893 3.27C17.2993 3.11 17.1293 3.02 16.9493 3.02C16.8893 3.02 16.8293 3.03 16.7793 3.05L14.2893 4.05C13.7693 3.65 13.2093 3.32 12.5993 3.07L12.2193 0.42C12.1893 0.18 11.9793 0 11.7293 0H7.72933C7.47933 0 7.26933 0.18 7.23933 0.42L6.85933 3.07C6.24933 3.32 5.68933 3.66 5.16933 4.05L2.67933 3.05C2.61933 3.03 2.55933 3.02 2.49933 3.02C2.32933 3.02 2.15933 3.11 2.06933 3.27L0.0693316 6.73C-0.0606684 6.95 -0.000668302 7.22 0.189332 7.37L2.29933 9.02C2.25933 9.34 2.22933 9.67 2.22933 10C2.22933 10.33 2.25933 10.66 2.29933 10.98L0.189332 12.63C-0.000668302 12.78 -0.0506684 13.05 0.0693316 13.27L2.06933 16.73C2.15933 16.89 2.32933 16.98 2.50933 16.98C2.56933 16.98 2.62933 16.97 2.67933 16.95L5.16933 15.95C5.68933 16.35 6.24933 16.68 6.85933 16.93L7.23933 19.58C7.26933 19.82 7.47933 20 7.72933 20H11.7293C11.9793 20 12.1893 19.82 12.2193 19.58L12.5993 16.93C13.2093 16.68 13.7693 16.34 14.2893 15.95L16.7793 16.95C16.8393 16.97 16.8993 16.98 16.9593 16.98C17.1293 16.98 17.2993 16.89 17.3893 16.73L19.3893 13.27C19.5093 13.05 19.4593 12.78 19.2693 12.63L17.1593 10.98V10.98ZM15.1793 9.27C15.2193 9.58 15.2293 9.79 15.2293 10C15.2293 10.21 15.2093 10.43 15.1793 10.73L15.0393 11.86L15.9293 12.56L17.0093 13.4L16.3093 14.61L15.0393 14.1L13.9993 13.68L13.0993 14.36C12.6693 14.68 12.2593 14.92 11.8493 15.09L10.7893 15.52L10.6293 16.65L10.4293 18H9.02933L8.83933 16.65L8.67933 15.52L7.61933 15.09C7.18933 14.91 6.78933 14.68 6.38933 14.38L5.47933 13.68L4.41933 14.11L3.14933 14.62L2.44933 13.41L3.52933 12.57L4.41933 11.87L4.27933 10.74C4.24933 10.43 4.22933 10.2 4.22933 10C4.22933 9.8 4.24933 9.57 4.27933 9.27L4.41933 8.14L3.52933 7.44L2.44933 6.6L3.14933 5.39L4.41933 5.9L5.45933 6.32L6.35933 5.64C6.78933 5.32 7.19933 5.08 7.60933 4.91L8.66933 4.48L8.82933 3.35L9.02933 2H10.4193L10.6093 3.35L10.7693 4.48L11.8293 4.91C12.2593 5.09 12.6593 5.32 13.0593 5.62L13.9693 6.32L15.0293 5.89L16.2993 5.38L16.9993 6.59L15.9293 7.44L15.0393 8.14L15.1793 9.27ZM9.72933 6C7.51933 6 5.72933 7.79 5.72933 10C5.72933 12.21 7.51933 14 9.72933 14C11.9393 14 13.7293 12.21 13.7293 10C13.7293 7.79 11.9393 6 9.72933 6ZM9.72933 12C8.62933 12 7.72933 11.1 7.72933 10C7.72933 8.9 8.62933 8 9.72933 8C10.8293 8 11.7293 8.9 11.7293 10C11.7293 11.1 10.8293 12 9.72933 12Z' />
        </svg>
    );
};

export const QuestionCircleIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='21'
            height='21'
            viewBox='0 0 21 21'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z' />
        </svg>
    );
};

export const SwapIcon = ({ onClick, className }: IconProps) => {
    return (
        <svg
            onClick={onClick}
            data-testid='swap-icon'
            className={className}
            version='1.1'
            id='Layer_1'
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            viewBox='0 0 512.003 512.003'
        >
            <g>
                <path
                    d='M440.448,87.831H114.629l52.495-52.495c8.084-8.084,8.084-21.19,0-29.274c-8.083-8.084-21.19-8.084-29.274,0
               L20.126,123.788c-8.084,8.084-8.084,21.19,0,29.274L137.85,270.786c4.041,4.042,9.338,6.062,14.636,6.062
               c5.298,0,10.596-2.02,14.636-6.064c8.084-8.084,8.084-21.19,0-29.274l-52.495-52.495h325.82c27.896,0,50.592-22.695,50.592-50.592
               C491.04,110.528,468.345,87.831,440.448,87.831z'
                />
            </g>

            <g>
                <path
                    d='M491.877,358.942L374.154,241.218c-8.083-8.084-21.19-8.084-29.274,0c-8.084,8.084-8.084,21.19,0,29.274l52.495,52.495
               H71.556c-27.896,0-50.592,22.695-50.592,50.592s22.695,50.593,50.592,50.593h325.819l-52.495,52.495
               c-8.084,8.084-8.084,21.19,0,29.274c4.042,4.042,9.34,6.064,14.636,6.064c5.296,0,10.596-2.02,14.636-6.064l117.724-117.724
               C499.961,380.132,499.961,367.026,491.877,358.942z'
                />
            </g>
        </svg>
    );
};

export const ArrowRightCircleIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-arrow-right-circle'
            viewBox='0 0 16 16'
        >
            <path
                fillRule='evenodd'
                d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'
            />
        </svg>
    );
};

export const InfoIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            width='8'
            height='7'
            viewBox='0 0 8 7'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            onClick={onClick}
        >
            <path
                d='M4.17768 1.07271L6.53455 3.50313L4.17768 5.93356C3.94077 6.17785 3.94077 6.57248 4.17768 6.81678C4.41458 7.06107 4.79727 7.06107 5.03417 6.81678L7.82232 3.94161C8.05923 3.69731 8.05923 3.30268 7.82232 3.05839L5.03417 0.183222C4.79727 -0.0610738 4.41458 -0.0610738 4.17768 0.183221C3.94685 0.427517 3.94077 0.828411 4.17768 1.07271Z'
                fill='#95AAC9'
            />
            <path
                d='M1.22223 7H0V3.27197C0 3.10628 0.134308 2.97197 0.300003 2.97197H6.7C6.86569 2.97197 7 3.10628 7 3.27197V3.72803C7 3.89371 6.86569 4.02803 6.7 4.02803H1.52223C1.35654 4.02803 1.22223 4.16235 1.22223 4.32803V7Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const SortArrowUpIcon: React.FC<IconProps> = ({
    onClick,
    className,
}) => {
    return (
        <svg
            onClick={onClick}
            width='8'
            height='4'
            viewBox='0 0 8 4'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M0 3.95833L3.95833 0L7.91667 3.95833H0Z' />
        </svg>
    );
};

export const SortArrowDownIcon: React.FC<IconProps> = ({
    onClick,
    className,
}) => {
    return (
        <svg
            onClick={onClick}
            width='8'
            height='5'
            viewBox='0 0 8 5'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M0 0.791667L3.95833 4.75L7.91667 0.791667H0Z' />
        </svg>
    );
};

export const NavbarDashboardIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='21'
            height='21'
            viewBox='0 0 21 21'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M2.55469 1.76064L13.4004 1.76068C13.2236 2.24361 13.127 2.76524 13.127 3.3094C13.127 3.60469 13.1553 3.89336 13.2095 4.17279H2.55469V18.7422H17.564V7.81442L17.6323 7.81493C18.3809 7.81493 19.0869 7.63239 19.708 7.30939V18.7422C19.708 19.9097 18.7432 20.865 17.564 20.865H2.55469C1.36475 20.865 0.410645 19.9097 0.410645 18.7422L0.421387 3.88333C0.421387 2.71585 1.36475 1.76064 2.55469 1.76064Z' />
            <path d='M15.2314 10.052C15.6543 9.50626 15.5547 8.7211 15.0088 8.29828C14.4629 7.87544 13.6777 7.97505 13.2549 8.52078L11.1997 11.1736L8.89502 9.36319C8.63281 9.15707 8.29883 9.06442 7.96729 9.10587C7.63623 9.14734 7.33545 9.31946 7.13232 9.58392L4.24414 13.3374C3.82324 13.8846 3.92529 14.6694 4.47266 15.0904C5.01953 15.5113 5.80469 15.4091 6.22559 14.8619L8.34375 12.1091L10.645 13.9169C10.9067 14.1226 11.2397 14.2153 11.5703 14.1744C11.9009 14.1336 12.2012 13.9627 12.4053 13.6995L15.2314 10.052Z' />
            <circle cx='17.6324' cy='3.3094' r='2.89459' fill='#ABD06D' />
        </svg>
    );
};

export const ArchiveIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='21'
            height='21'
            viewBox='0 0 21 21'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M14.2458 6.375H11.5895V3.25H8.56868V6.375H5.91243L10.0791 10.5417L14.2458 6.375ZM17.3708 0.125H2.77702C1.62077 0.125 0.704102 1.0625 0.704102 2.20833V16.7917C0.704102 17.9375 1.62077 18.875 2.77702 18.875H17.3708C18.5166 18.875 19.4541 17.9375 19.4541 16.7917V2.20833C19.4541 1.0625 18.5166 0.125 17.3708 0.125ZM17.3708 16.7917H2.78743V13.6667H6.49577C7.21452 14.9062 8.54785 15.75 10.0895 15.75C11.6312 15.75 12.9541 14.9062 13.6833 13.6667H17.3708V16.7917ZM17.3708 11.5833H12.1729C12.1729 12.7292 11.2354 13.6667 10.0895 13.6667C8.94368 13.6667 8.00618 12.7292 8.00618 11.5833H2.78743L2.77702 2.20833H17.3708V11.5833Z' />
        </svg>
    );
};

export const CircleCheck = () => {
    return (
        <svg
            width='17'
            height='17'
            viewBox='0 0 17 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.82456 9.38782L4.89667 7.48886L3.93725 8.43388L6.81551 11.2689L12.2462 5.91976L11.2868 4.97474L6.82456 9.38782ZM8.14602 0C3.64761 0 0 3.59287 0 8.02377C0 12.4547 3.64761 16.0475 8.14602 16.0475C12.6444 16.0475 16.292 12.4547 16.292 8.02377C16.292 3.59287 12.6444 0 8.14602 0ZM8.14602 14.2645C4.65229 14.2645 1.81023 11.4651 1.81023 8.02377C1.81023 4.58247 4.65229 1.78306 8.14602 1.78306C11.6398 1.78306 14.4818 4.58247 14.4818 8.02377C14.4818 11.4651 11.6398 14.2645 8.14602 14.2645Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const UploadFileIcon = () => {
    return (
        <svg
            width='24'
            height='28'
            viewBox='0 0 24 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.08984 2.37549V25.3242H12.2635C12.8157 25.3242 13.2635 25.772 13.2635 26.3242C13.2635 26.8765 12.8157 27.3242 12.2635 27.3242H1.58984C0.761418 27.3242 0.0898438 26.6527 0.0898438 25.8242V1.87549C0.0898438 1.04706 0.761415 0.375488 1.58984 0.375488H12.9106C13.3178 0.375488 13.7075 0.54103 13.9902 0.834094L19.7191 6.77314C19.9888 7.05273 20.1395 7.42605 20.1395 7.81453V10.8388H18.1395V10.1187H13.404C11.7471 10.1187 10.404 8.77551 10.404 7.11865V2.37549H2.08984ZM18.1395 8.01638V8.11866H13.404C12.8517 8.11866 12.404 7.67094 12.404 7.11865V2.37549H12.6982L18.1395 8.01638ZM18.8856 25.7745C18.3333 25.7745 17.8856 25.3268 17.8856 24.7745V21.8762H14.9873C14.435 21.8762 13.9873 21.4285 13.9873 20.8762C13.9873 20.3239 14.435 19.8762 14.9873 19.8762H17.8856V16.978C17.8856 16.4258 18.3333 15.978 18.8856 15.978C19.4378 15.978 19.8856 16.4258 19.8856 16.978V19.8762H22.7838C23.3361 19.8762 23.7838 20.3239 23.7838 20.8762C23.7838 21.4285 23.3361 21.8762 22.7838 21.8762H19.8856V24.7745C19.8856 25.3268 19.4378 25.7745 18.8856 25.7745Z'
                fill='#1F2756'
            />
            <rect
                width='1.42208'
                height='1.973'
                transform='matrix(1 0 0 -1 0.0898438 2.34814)'
                fill='#1F2756'
            />
            <rect
                width='13.4971'
                height='2.01632'
                transform='matrix(1 0 0 -1 0.0898438 27.3247)'
                fill='#1F2756'
            />
            <rect
                width='1.42208'
                height='3.25425'
                transform='matrix(1 0 0 -1 10.396 10.0991)'
                fill='#1F2756'
            />
            <rect
                width='8.25'
                height='1.4375'
                transform='matrix(1 0 0 -1 10.396 10.1929)'
                fill='#1F2756'
            />
            <rect
                width='3.67188'
                height='1.4375'
                transform='matrix(1 0 0 -1 12.4272 8.11279)'
                fill='#F9FAFC'
            />
        </svg>
    );
};

export const AddCircleIcon = () => {
    return (
        <svg
            width='55'
            height='55'
            viewBox='0 0 55 55'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='1'
                y='1'
                width='53'
                height='53'
                rx='26.5'
                fill='white'
                stroke='#D2DDEC'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M38.0174 28.9702V26.7264H29.1219V17.8309H26.8781V26.7264H17.9826V28.9702H26.8781V37.8657H29.1219V28.9702H38.0174Z'
                fill='black'
            />
        </svg>
    );
};

export const CircledDownloadIcon: React.FC<IconProps> = ({ onClick }) => (
    <svg
        onClick={onClick}
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            x='1'
            y='1'
            width='38'
            height='38'
            rx='19'
            fill='white'
            stroke='#E3EBF6'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M26 23V26H14V23H12V26C12 27.1 12.9 28 14 28H26C27.1 28 28 27.1 28 26V23H26ZM25 19L23.59 17.59L21 20.17V12H19V20.17L16.41 17.59L15 19L20 24L25 19Z'
            fill='#35336C'
        />
    </svg>
);

export const ExtensionRequestMedicalPendingIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='40'
            viewBox='0 0 42 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H22.0876C22.0876 26.2246 25.9674 21.7386 31.0876 20.7981V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#FDEFD8'
            />
            <circle cx='34.0876' cy='32.6168' r='7' fill='#F7B548' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.0305 10.9024H20.2019V8.75966C20.2019 7.57034 19.2865 6.61676 18.1448 6.61676H14.0305C12.8888 6.61676 11.9733 7.57034 11.9733 8.75966V10.9024H9.14476C8.00304 10.9024 7.09793 11.856 7.09793 13.0453L7.08765 21.9381C7.08765 23.1274 8.00304 24.081 9.14476 24.081H23.0305C24.1722 24.081 25.0876 23.1274 25.0876 21.9381V13.0453C25.0876 11.856 24.1722 10.9024 23.0305 10.9024ZM18.1448 10.9024H14.0305V8.75966H18.1448V10.9024ZM17.4035 15.7596H19.9749V18.4739H17.4035V21.1882H14.8321V18.4739H12.2606V15.7596H14.8321V13.0453H17.4035V15.7596Z'
                fill='#F7B548'
            />
            <path
                d='M32.0876 32.6168C32.0876 32.0668 31.6376 31.6168 31.0876 31.6168C30.5376 31.6168 30.0876 32.0668 30.0876 32.6168C30.0876 33.1668 30.5376 33.6168 31.0876 33.6168C31.6376 33.6168 32.0876 33.1668 32.0876 32.6168ZM33.0876 32.6168C33.0876 33.1668 33.5376 33.6168 34.0876 33.6168C34.6376 33.6168 35.0876 33.1668 35.0876 32.6168C35.0876 32.0668 34.6376 31.6168 34.0876 31.6168C33.5376 31.6168 33.0876 32.0668 33.0876 32.6168ZM36.0876 32.6168C36.0876 33.1668 36.5376 33.6168 37.0876 33.6168C37.6376 33.6168 38.0876 33.1668 38.0876 32.6168C38.0876 32.0668 37.6376 31.6168 37.0876 31.6168C36.5376 31.6168 36.0876 32.0668 36.0876 32.6168Z'
                fill='white'
            />
        </svg>
    );
};

export const ExtensionRequestMedicalAcceptedIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='40'
            viewBox='0 0 42 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H22.0876C22.0876 26.2246 25.9674 21.7386 31.0876 20.7981V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#E4EDD9'
            />
            <circle cx='34.0876' cy='32.6168' r='7' fill='#79A342' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.0305 10.9024H20.2019V8.75966C20.2019 7.57034 19.2865 6.61676 18.1448 6.61676H14.0305C12.8888 6.61676 11.9733 7.57034 11.9733 8.75966V10.9024H9.14476C8.00304 10.9024 7.09793 11.856 7.09793 13.0453L7.08765 21.9381C7.08765 23.1274 8.00304 24.081 9.14476 24.081H23.0305C24.1722 24.081 25.0876 23.1274 25.0876 21.9381V13.0453C25.0876 11.856 24.1722 10.9024 23.0305 10.9024ZM18.1448 10.9024H14.0305V8.75966H18.1448V10.9024ZM17.4035 15.7596H19.9749V18.4739H17.4035V21.1882H14.8321V18.4739H12.2606V15.7596H14.8321V13.0453H17.4035V15.7596Z'
                fill='#79A342'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M36.9657 30.3031C37.0438 30.3862 37.0876 30.4989 37.0876 30.6164C37.0876 30.7339 37.0438 30.8466 36.9657 30.9297L33.4603 34.5663C33.3822 34.6493 33.2762 34.696 33.1657 34.696C33.0553 34.696 32.9493 34.6493 32.8712 34.5663L31.2046 32.7937C31.1287 32.7101 31.0867 32.5982 31.0877 32.482C31.0886 32.3658 31.1324 32.2547 31.2097 32.1725C31.2869 32.0904 31.3914 32.0438 31.5007 32.0427C31.6099 32.0417 31.7152 32.0864 31.7937 32.1671L33.1657 33.6264L36.3765 30.3031C36.4547 30.2201 36.5606 30.1734 36.6711 30.1734C36.7816 30.1734 36.8875 30.2201 36.9657 30.3031Z'
                fill='white'
                stroke='white'
                strokeWidth='0.5'
            />
        </svg>
    );
};

export const ExtensionRequestMedicalDeclinedIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='40'
            viewBox='0 0 42 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H22.1325C22.5776 26.6776 26.2875 22.6799 31.0876 21.7981V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#FFE6E1'
            />
            <circle cx='34.0876' cy='32.6168' r='7' fill='#F66B4F' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.0305 10.9024H20.2019V8.75966C20.2019 7.57034 19.2865 6.61676 18.1448 6.61676H14.0305C12.8888 6.61676 11.9733 7.57034 11.9733 8.75966V10.9024H9.14476C8.00304 10.9024 7.09793 11.856 7.09793 13.0453L7.08765 21.9381C7.08765 23.1274 8.00304 24.081 9.14476 24.081H23.0305C24.1722 24.081 25.0876 23.1274 25.0876 21.9381V13.0453C25.0876 11.856 24.1722 10.9024 23.0305 10.9024ZM18.1448 10.9024H14.0305V8.75966H18.1448V10.9024ZM17.4035 15.7596H19.9749V18.4739H17.4035V21.1882H14.8321V18.4739H12.2606V15.7596H14.8321V13.0453H17.4035V15.7596Z'
                fill='#F66B4F'
            />
            <path
                d='M36.9812 31.2366L37.0872 31.3426C37.2878 31.1421 37.2878 30.8177 37.0872 30.6172C36.8867 30.4166 36.5623 30.4166 36.3618 30.6172L36.4679 30.7232L36.3618 30.6172L34.6875 32.2914L33.0135 30.6208C33.0135 30.6208 33.0135 30.6208 33.0134 30.6208L33.0134 30.6207L32.9074 30.7269L36.9812 31.2366ZM36.9812 31.2366L37.0872 31.3426L35.4131 33.0168L37.0872 34.6909C37.2878 34.8915 37.2878 35.2158 37.0872 35.4163H37.0872C36.8867 35.6169 36.5623 35.6169 36.3618 35.4163L34.6876 33.7422L33.0135 35.4163C32.813 35.6169 32.4886 35.6169 32.2881 35.4163C32.0875 35.2158 32.0875 34.8915 32.2881 34.6909L33.9622 33.0168L36.9812 31.2366Z'
                fill='white'
                stroke='white'
                strokeWidth='0.3'
            />
        </svg>
    );
};

export const ExtensionRequestAcademicPendingIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='37'
            viewBox='0 0 42 37'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H22.269C22.1499 30.9682 22.0876 30.2998 22.0876 29.6168C22.0876 24.2246 25.9674 19.7386 31.0876 18.7981V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#FDEFD8'
            />
            <path
                d='M8.86895 16.6555V19.6195C8.86895 20.3895 9.25158 21.1068 9.8638 21.476L14.6468 24.3557C15.2207 24.7038 15.9095 24.7038 16.4834 24.3557L21.2664 21.476C21.8786 21.1068 22.2613 20.3895 22.2613 19.6195V16.6555L16.4834 20.1364C15.9095 20.4845 15.2207 20.4845 14.6468 20.1364L8.86895 16.6555ZM14.6468 6.86998L6.58268 11.318C5.92263 11.7189 5.92263 12.7737 6.58268 13.1745L14.6468 18.0267C15.2207 18.3748 15.9095 18.3748 16.4834 18.0267L24.1745 13.396V19.6301C24.1745 20.2102 24.6049 20.6849 25.1311 20.6849C25.6572 20.6849 26.0876 20.2102 26.0876 19.6301V12.8686C26.0876 12.4783 25.8963 12.1302 25.5902 11.9404L16.4834 6.86998C15.9095 6.53244 15.2207 6.53244 14.6468 6.86998Z'
                fill='#F7B548'
            />
            <circle cx='34.0876' cy='29.6168' r='7' fill='#F7B548' />
            <path
                d='M32.0876 29.6168C32.0876 29.0668 31.6376 28.6168 31.0876 28.6168C30.5376 28.6168 30.0876 29.0668 30.0876 29.6168C30.0876 30.1668 30.5376 30.6168 31.0876 30.6168C31.6376 30.6168 32.0876 30.1668 32.0876 29.6168ZM33.0876 29.6168C33.0876 30.1668 33.5376 30.6168 34.0876 30.6168C34.6376 30.6168 35.0876 30.1668 35.0876 29.6168C35.0876 29.0668 34.6376 28.6168 34.0876 28.6168C33.5376 28.6168 33.0876 29.0668 33.0876 29.6168ZM36.0876 29.6168C36.0876 30.1668 36.5376 30.6168 37.0876 30.6168C37.6376 30.6168 38.0876 30.1668 38.0876 29.6168C38.0876 29.0668 37.6376 28.6168 37.0876 28.6168C36.5376 28.6168 36.0876 29.0668 36.0876 29.6168Z'
                fill='white'
            />
        </svg>
    );
};

export const ExtensionRequestAcademicAcceptedIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='37'
            viewBox='0 0 42 37'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H21.269C21.1499 30.9682 21.0876 30.2998 21.0876 29.6168C21.0876 23.8787 25.4811 19.1668 31.0876 18.6616V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#E4EDD9'
            />
            <path
                d='M8.86895 16.6555V19.6195C8.86895 20.3895 9.25158 21.1068 9.8638 21.476L14.6468 24.3557C15.2207 24.7038 15.9095 24.7038 16.4834 24.3557L21.2664 21.476C21.8786 21.1068 22.2613 20.3895 22.2613 19.6195V16.6555L16.4834 20.1364C15.9095 20.4845 15.2207 20.4845 14.6468 20.1364L8.86895 16.6555ZM14.6468 6.86998L6.58268 11.318C5.92263 11.7189 5.92263 12.7737 6.58268 13.1745L14.6468 18.0267C15.2207 18.3748 15.9095 18.3748 16.4834 18.0267L24.1745 13.396V19.6301C24.1745 20.2102 24.6049 20.6849 25.1311 20.6849C25.6572 20.6849 26.0876 20.2102 26.0876 19.6301V12.8686C26.0876 12.4783 25.8963 12.1302 25.5902 11.9404L16.4834 6.86998C15.9095 6.53244 15.2207 6.53244 14.6468 6.86998Z'
                fill='#79A342'
            />
            <circle cx='34.0876' cy='29.6168' r='7' fill='#79A342' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M36.9657 27.3031C37.0438 27.3862 37.0876 27.4989 37.0876 27.6164C37.0876 27.7339 37.0438 27.8466 36.9657 27.9297L33.4603 31.5663C33.3822 31.6493 33.2762 31.696 33.1657 31.696C33.0553 31.696 32.9493 31.6493 32.8712 31.5663L31.2046 29.7937C31.1287 29.7101 31.0867 29.5982 31.0877 29.482C31.0886 29.3658 31.1324 29.2547 31.2097 29.1725C31.2869 29.0904 31.3914 29.0438 31.5007 29.0427C31.6099 29.0417 31.7152 29.0864 31.7937 29.1671L33.1657 30.6264L36.3765 27.3031C36.4547 27.2201 36.5606 27.1734 36.6711 27.1734C36.7816 27.1734 36.8875 27.2201 36.9657 27.3031Z'
                fill='white'
                stroke='white'
                strokeWidth='0.5'
            />
        </svg>
    );
};

export const ExtensionRequestAcademicDeclinedIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='42'
            height='37'
            viewBox='0 0 42 37'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='extension-request-badge-icon'
            role='img'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0.52362 2.8008C0.0876465 3.65645 0.0876465 4.77655 0.0876465 7.01676V25.2168C0.0876465 27.457 0.0876465 28.5771 0.52362 29.4327C0.907114 30.1854 1.51904 30.7973 2.27168 31.1808C3.12733 31.6168 4.24744 31.6168 6.48765 31.6168H22.5017C22.232 30.6631 22.0876 29.6568 22.0876 28.6168C22.0876 23.2246 25.9674 18.7386 31.0876 17.7981V7.01676C31.0876 4.77655 31.0876 3.65645 30.6517 2.8008C30.2682 2.04815 29.6563 1.43623 28.9036 1.05273C28.048 0.61676 26.9279 0.61676 24.6876 0.61676H6.48765C4.24744 0.61676 3.12733 0.61676 2.27168 1.05273C1.51904 1.43623 0.907114 2.04815 0.52362 2.8008Z'
                fill='#FFE6E1'
            />
            <path
                d='M8.86895 16.6555V19.6195C8.86895 20.3895 9.25158 21.1068 9.8638 21.476L14.6468 24.3557C15.2207 24.7038 15.9095 24.7038 16.4834 24.3557L21.2664 21.476C21.8786 21.1068 22.2613 20.3895 22.2613 19.6195V16.6555L16.4834 20.1364C15.9095 20.4845 15.2207 20.4845 14.6468 20.1364L8.86895 16.6555ZM14.6468 6.86998L6.58268 11.318C5.92263 11.7189 5.92263 12.7737 6.58268 13.1745L14.6468 18.0267C15.2207 18.3748 15.9095 18.3748 16.4834 18.0267L24.1745 13.396V19.6301C24.1745 20.2102 24.6049 20.6849 25.1311 20.6849C25.6572 20.6849 26.0876 20.2102 26.0876 19.6301V12.8686C26.0876 12.4783 25.8963 12.1302 25.5902 11.9404L16.4834 6.86998C15.9095 6.53244 15.2207 6.53244 14.6468 6.86998Z'
                fill='#F66B4F'
            />
            <circle cx='34.0876' cy='29.6168' r='7' fill='#F66B4F' />
            <path
                d='M36.9812 28.2366L37.0872 28.3426C37.2878 28.1421 37.2878 27.8177 37.0872 27.6172C36.8867 27.4166 36.5623 27.4166 36.3618 27.6172L36.4679 27.7232L36.3618 27.6172L34.6875 29.2914L33.0135 27.6208C33.0135 27.6208 33.0135 27.6208 33.0134 27.6208L33.0134 27.6207L32.9074 27.7269L36.9812 28.2366ZM36.9812 28.2366L37.0872 28.3426L35.4131 30.0168L37.0872 31.6909C37.2878 31.8915 37.2878 32.2158 37.0872 32.4163H37.0872C36.8867 32.6169 36.5623 32.6169 36.3618 32.4163L34.6876 30.7422L33.0135 32.4163C32.813 32.6169 32.4886 32.6169 32.2881 32.4163C32.0875 32.2158 32.0875 31.8915 32.2881 31.6909L33.9622 30.0168L36.9812 28.2366Z'
                fill='white'
                stroke='white'
                strokeWidth='0.3'
            />
        </svg>
    );
};

export const FolderIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='23'
            height='19'
            viewBox='0 0 23 19'
            style={{ marginRight: '10px' }}
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M20.5 2.75H11.5L9.25 0.5H2.5C1.2625 0.5 0.26125 1.5125 0.26125 2.75L0.25 16.25C0.25 17.4875 1.2625 18.5 2.5 18.5H20.5C21.7375 18.5 22.75 17.4875 22.75 16.25V5C22.75 3.7625 21.7375 2.75 20.5 2.75ZM20.5 16.25H2.5V5H20.5V16.25Z' />
        </svg>
    );
};

export const ExclamationIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='19'
            height='17'
            viewBox='0 0 19 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.9'
                d='M9.31914 7.24638V8.99711M9.31914 12.4986H9.32764M1 16H18C18 16 18 16 16.6843 13.3739L9.68085 1L1 16Z'
                stroke='#C12743'
                strokeWidth='2'
                strokeLinecap='square'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const EmailIcon = ({ color }: { color?: string }) => {
    return (
        <svg
            width='16'
            height='14'
            viewBox='0 0 16 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.873 0H1.54145C0.693651 0 0.00770723 0.693651 0.00770723 1.54145L0 11.6586C0 12.5063 0.693651 13.2 1.54145 13.2H13.873C14.7208 13.2 15.4145 12.5063 15.4145 11.6586V1.54145C15.4145 0.693651 14.7208 0 13.873 0ZM13.873 11.6586H1.54145V3.08289L7.70724 6.93651L13.873 3.08289V11.6586ZM7.70724 5.39507L1.54145 1.54145H13.873L7.70724 5.39507Z'
                fill={color ? color : '#95AAC9'}
            />
        </svg>
    );
};

export const CriteriaIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-check2-circle'
            viewBox='0 0 16 16'
        >
            <path d='M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z' />
            <path d='M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z' />
        </svg>
    );
};

export const CheckedIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='currentColor'
            className='bi bi-check-circle-fill'
            viewBox='0 0 16 16'
        >
            <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
        </svg>
    );
};

export const EditIconBox: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='16'
            height='14'
            viewBox='0 0 16 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.2716 1.67227L12.2885 0.68884C11.6547 0.0548919 10.6229 0.0548919 9.9891 0.68884L7.8116 2.86702L0.750977 9.92985V13.2134H4.03348L11.1347 6.10991L13.2716 3.97237C13.9135 3.33842 13.9135 2.30622 13.2716 1.67227ZM3.3591 11.5879H2.37598V10.6044L9.41223 3.56599L10.3954 4.54942L3.3591 11.5879ZM7.25098 13.2134L10.501 10.7749H15.376V13.2134H7.25098Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const PlusIcon24: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            width='18'
            height='18'
            onClick={onClick}
            viewBox='0 0 17 17'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.655 9.63632L16.655 7.82348L9.46794 7.82348L9.46794 0.636401H7.6551L7.6551 7.82348L0.468024 7.82348L0.468024 9.63632L7.6551 9.63632V16.8234H9.46794V9.63632L16.655 9.63632Z'
                fill='#35336C'
            />
        </svg>
    );
};

export const BasicXIcon = ({
    width,
    height,
}: {
    width?: string;
    height?: string;
}) => {
    return (
        <svg
            cursor='pointer'
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? '16'}
            height={height ?? '16'}
            fill='currentColor'
            className='bi bi-x-lg'
            viewBox='0 0 16 16'
            data-testid='basic-x-icon'
        >
            <path d='M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z' />
        </svg>
    );
};

/// Admin widgets

export const ProposalProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#EFB421'
            />
            <g clipPath='url(#clip0)'>
                <path
                    d='M32 14H20C18.9 14 18 14.9 18 16V30H20V16H32V14ZM31 18L37 24V34C37 35.1 36.1 36 35 36H23.99C22.89 36 22 35.1 22 34L22.01 20C22.01 18.9 22.9 18 24 18H31ZM30 25H35.5L30 19.5V25Z'
                    fill='#EFB421'
                />
            </g>
            <defs>
                <clipPath id='clip0'>
                    <rect
                        width='24'
                        height='24'
                        fill='white'
                        transform='translate(12 13)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DeclineProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#C12743'
            />
            <path
                d='M31 15H19C17.9 15 17 15.9 17 17V31H19V17H31V15ZM30 19L36 25V29.5C36 29.5 30.6 28 29.5 28L22.99 37C21.89 37 21 36.1 21 35L21.01 21C21.01 19.9 21.9 19 23 19H30ZM29 26H34.5L29 20.5V26Z'
                fill='#C12743'
            />
            <path
                d='M31 15H19C17.9 15 17 15.9 17 17V31H19V17H31V15Z'
                fill='#C12743'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M26.0267 36.4724C26.0089 36.3205 26 36.1603 26 36V37H23C21.9 37 21 36.1 21 35V21C21 19.9 21.9 19 23 19L25 24C26.1 24 27 24.9 27 26L36 29.68C35.09 29.25 34.08 29 33 29C29.2894 29 26.2591 31.8775 26.0158 35.5257C26.019 36.0111 26.0226 36.3682 26.0267 36.4724ZM26.0158 35.5257C26.0053 35.6824 26 35.8406 26 36V31C26 30.8768 26.0053 33.9112 26.0158 35.5257Z'
                fill='#C12743'
            />
            <path
                d='M26.03 36.5C26.0289 36.4909 26.0277 36.4816 26.0267 36.4724C26.0277 36.4998 26.0289 36.5097 26.03 36.5Z'
                fill='#C12743'
            />
            <path
                d='M36.0625 32L32.975 35.0875L29.8875 32L29 32.8875L32.0875 35.975L29 39.0625L29.8875 39.95L32.975 36.8625L36.0625 39.95L36.95 39.0625L33.8625 35.975L36.95 32.8875L36.0625 32Z'
                fill='#C12743'
            />
        </svg>
    );
};

export const ActiveProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#79A342'
            />
            <path
                d='M32 15H20C18.9 15 18 15.9 18 17V31H20V17H32V15ZM31 19L37 25V29.5C37 29.5 31.6 28 30.5 28L23.99 37C22.89 37 22 36.1 22 35L22.01 21C22.01 19.9 22.9 19 24 19H31ZM30 26H35.5L30 20.5V26Z'
                fill='#79A342'
            />
            <path
                d='M32 15H20C18.9 15 18 15.9 18 17V31H20V17H32V15Z'
                fill='#79A342'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M27.0267 36.4724C27.0089 36.3205 27 36.1603 27 36V37H24C22.9 37 22 36.1 22 35V21C22 19.9 22.9 19 24 19L26 24C27.1 24 28 24.9 28 26L37 29.68C36.09 29.25 35.08 29 34 29C30.2894 29 27.2591 31.8775 27.0158 35.5257C27.019 36.0111 27.0226 36.3682 27.0267 36.4724ZM27.0158 35.5257C27.0053 35.6824 27 35.8406 27 36V31C27 30.8768 27.0053 33.9112 27.0158 35.5257Z'
                fill='#79A342'
            />
            <path
                d='M27.03 36.5C27.0289 36.4909 27.0277 36.4816 27.0267 36.4724C27.0277 36.4998 27.0289 36.5097 27.03 36.5Z'
                fill='#79A342'
            />
            <path
                d='M33.2292 28C36.9567 28 39.9792 31.0225 39.9792 34.75H42.2292L39.3117 37.6675L39.2592 37.7725L36.2292 34.75H38.4792C38.4792 31.8475 36.1317 29.5 33.2292 29.5C30.3267 29.5 27.9792 31.8475 27.9792 34.75C27.9792 37.6525 30.3267 40 33.2292 40C34.6767 40 35.9892 39.4075 36.9342 38.455L37.9992 39.52C36.7767 40.7425 35.0967 41.5 33.2292 41.5C29.5017 41.5 26.4792 38.4775 26.4792 34.75C26.4792 31.0225 29.5017 28 33.2292 28ZM33.9792 31.75V35.5L30.7917 37.39L30.2142 36.43L32.8542 34.8625V31.75H33.9792Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const SupervisorNextGradingIcon = () => {
    return (
        <svg
            width='19'
            height='21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.889 2.1h-1.056V1.05a1.056 1.056 0 0 0-2.11 0V2.1H5.277V1.05a1.056 1.056 0 0 0-2.111 0V2.1H2.11c-1.172 0-2.1.945-2.1 2.1L0 18.9C0 20.055.94 21 2.111 21H16.89A2.112 2.112 0 0 0 19 18.9V4.2c0-1.155-.95-2.1-2.111-2.1Zm0 15.75c0 .577-.475 1.05-1.056 1.05H3.167c-.58 0-1.056-.473-1.056-1.05V7.35H16.89v10.5ZM4.222 9.45h2.111v2.1h-2.11v-2.1Zm4.222 0h2.112v2.1H8.444v-2.1Zm4.223 0h2.11v2.1h-2.11v-2.1Z'
                fill='#fff'
            />
        </svg>
    );
};

export const SupervisorPublishedResearchAreasIcon = () => {
    return (
        <svg
            width='20'
            height='20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M2 4H0v14c0 1.1.9 2 2 2h14v-2H2V4Z' fill='#95AAC9' />
            <path
                d='M12.5 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5ZM6 0h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2Zm1.92 13.5 2.2-2.2c.9.58 2.03.84 3.22.62 1.88-.35 3.38-1.93 3.62-3.83a4.505 4.505 0 0 0-5.21-5.04c-1.88.3-3.39 1.84-3.7 3.71a4.43 4.43 0 0 0 .64 3.12l-2.2 2.19a1.011 1.011 0 0 0 1.43 1.43Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const SecondSupervisorInvitationsIcon = () => {
    return (
        <svg
            width='21'
            height='19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M19 7.6V1.9C19 .855 18.145 0 17.1 0H1.9C.855 0 .01.855.01 1.9L0 13.3c0 1.045.855 1.9 1.9 1.9h10.45v-4.75A2.846 2.846 0 0 1 15.2 7.6H19Zm-8.996.636a.96.96 0 0 1-1.008 0L2.28 4.037a.807.807 0 1 1 .855-1.368L9.5 6.65l6.365-3.98a.807.807 0 1 1 .855 1.367l-6.716 4.2Z'
                fill='#95AAC9'
            />
            <path
                d='M19.95 11.4a.953.953 0 0 0-.95.95v2.85c0 1.045-.855 1.9-1.9 1.9s-1.9-.855-1.9-1.9v-4.275a.47.47 0 0 1 .475-.475.47.47 0 0 1 .475.475v3.325c0 .523.428.95.95.95s.95-.427.95-.95v-3.325a2.376 2.376 0 0 0-4.75 0V15.2c0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8v-2.85a.953.953 0 0 0-.95-.95Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const SupervisorInvitationsIcon = () => {
    return (
        <svg
            width='27'
            height='26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M20 11c-.7 0-1.37.1-2 .29V5c0-1.1-.9-2-2-2s0 .9 0 2l-2.32 14c0 1.1-9.78 2-8.68 2h8.68A6.999 6.999 0 0 0 27 18c0-3.87-3.13-7-7-7Zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z'
                fill='#95AAC9'
            />
            <path
                d='M16.222 3H3.778C2.8 3 2 3.9 2 5v14c0 1.1.8 2 1.778 2h9.778C15 13.5 18 13.1 18 12V5c0-1.1-.8-2-1.778-2ZM19.668 20.14a.693.693 0 0 1-.984 0l-1.48-1.485a.7.7 0 0 1 0-.988.693.693 0 0 1 .984 0l.985.988 2.639-2.684a.693.693 0 0 1 .984 0 .7.7 0 0 1 0 .987l-3.128 3.182Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const ActiveSupervisorProjectIcon = () => {
    return (
        <svg
            width='25'
            height='25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M18 11c-.7 0-1.37.1-2 .29V5c0-1.1-.9-2-2-2s0 .9 0 2l-2.32 14c0 1.1-9.78 2-8.68 2h8.68A6.999 6.999 0 0 0 25 18c0-3.87-3.13-7-7-7Zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z'
                fill='#95AAC9'
            />
            <path
                d='M14.222 3H1.778C.8 3 0 3.9 0 5v14c0 1.1.8 2 1.778 2h9.778C13 13.5 16 13.1 16 12V5c0-1.1-.8-2-1.778-2ZM8.89 17H4.444c-.488 0-.888-.45-.888-1s.4-1 .888-1H8.89c.489 0 .889.45.889 1s-.4 1-.89 1Zm2.667-4H4.444c-.488 0-.888-.45-.888-1s.4-1 .888-1h7.112c.488 0 .888.45.888 1s-.4 1-.888 1Zm0-4H4.444c-.488 0-.888-.45-.888-1s.4-1 .888-1h7.112c.488 0 .888.45.888 1s-.4 1-.888 1ZM17.668 20.14a.693.693 0 0 1-.984 0l-1.48-1.485a.7.7 0 0 1 0-.988.693.693 0 0 1 .984 0l.985.988 2.639-2.684a.693.693 0 0 1 .984 0 .7.7 0 0 1 0 .987l-3.128 3.182Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const ApprovedProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#5aadc8'
            />
            <path
                d='M34 19V31H22V19H34ZM34 17H22C20.9 17 20 17.9 20 19V31C20 32.1 20.9 33 22 33H34C35.1 33 36 32.1 36 31V19C36 17.9 35.1 17 34 17ZM26.47 29L23 25.5L24.4 24.09L26.47 26.17L31.6 21L33 22.41L26.47 29ZM18 21H16V35C16 36.1 16.9 37 18 37H32V35H18V21Z'
                fill='#64A6C8'
            />
        </svg>
    );
};

export const SubmittedProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#7061D4'
            />
            <g clipPath='url(#clip0)'>
                <path
                    d='M33 15H21C19.9 15 19 15.9 19 17V31H21V17H33V15ZM32 19L38 25V35C38 36.1 37.1 37 36 37H24.99C23.89 37 23 36.1 23 35L23.01 21C23.01 19.9 23.9 19 25 19H32ZM31 26H36.5L31 20.5V26Z'
                    fill='#7061D4'
                />
                <circle cx='26.5' cy='36.5' r='7.5' fill='#E7E5F8' />
            </g>
            <path
                d='M26.4444 38.7273H28V33H22.5556V34.6364H25.3478L21 39.21L22.0967 40.3636L26.4444 35.79V38.7273Z'
                fill='#7061D4'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.9733 36.4724C32.9911 36.3205 33 36.1603 33 36V37H36C37.1 37 38 36.1 38 35V30C38 28.9 37.1 28 36 28L34 26C32.9 26 25.5 24.9 25.5 26L23 29.68C23.91 29.25 24.92 29 26 29C29.7106 29 32.7409 31.8774 32.9842 35.5257C32.981 36.0111 32.9774 36.3682 32.9733 36.4724ZM32.9842 35.5257C32.9947 35.6824 33 35.8406 33 36V31C33 30.8767 32.9947 33.9112 32.9842 35.5257Z'
                fill='#7061D4'
            />
            <path
                d='M32.97 36.5C32.9711 36.4908 32.9723 36.4816 32.9733 36.4724C32.9723 36.4998 32.9711 36.5097 32.97 36.5Z'
                fill='#7061D4'
            />
            <defs>
                <clipPath id='clip0'>
                    <rect
                        width='29'
                        height='24'
                        fill='white'
                        transform='translate(13 14)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const RegisteredProjectIcon = () => {
    return (
        <svg
            width='53'
            height='53'
            viewBox='0 0 53 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M26.5 53C41.1355 53 53 41.1355 53 26.5C53 11.8645 41.1355 0 26.5 0C11.8645 0 0 11.8645 0 26.5C0 41.1355 11.8645 53 26.5 53Z'
                fill='#79A342'
            />
            <path
                d='M33 18H28.82C28.4 16.84 27.3 16 26 16C24.7 16 23.6 16.84 23.18 18H19C17.9 18 17 18.9 17 20V34C17 35.1 17.9 36 19 36H33C34.1 36 35 35.1 35 34V20C35 18.9 34.1 18 33 18ZM26 18C26.55 18 27 18.45 27 19C27 19.55 26.55 20 26 20C25.45 20 25 19.55 25 19C25 18.45 25.45 18 26 18ZM24 32L20 28L21.41 26.59L24 29.17L30.59 22.58L32 24L24 32Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const OverdueProjectIcon = () => {
    return (
        <svg
            width='54'
            height='53'
            viewBox='0 0 54 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M27.2947 53C41.9302 53 53.7947 41.1355 53.7947 26.5C53.7947 11.8645 41.9302 0 27.2947 0C12.6591 0 0.794678 11.8645 0.794678 26.5C0.794678 41.1355 12.6591 53 27.2947 53Z'
                fill='#95AAC9'
            />
            <path
                d='M37 23.9111H29.4662L32.5108 20.7778C29.4773 17.7778 24.5658 17.6667 21.5323 20.6667C18.4987 23.6778 18.4987 28.5333 21.5323 31.5444C24.5658 34.5556 29.4773 34.5556 32.5108 31.5444C34.022 30.0556 34.7776 28.3111 34.7776 26.1111H37C37 28.3111 36.0222 31.1667 34.0665 33.1C30.1662 36.9667 23.8324 36.9667 19.9322 33.1C16.043 29.2444 16.0097 22.9778 19.91 19.1222C23.8102 15.2667 30.0662 15.2667 33.9665 19.1222L37 16V23.9111ZM27.5549 21.5556V26.2778L31.4441 28.5889L30.644 29.9333L25.8881 27.1111V21.5556H27.5549Z'
                fill='#35336C'
            />
        </svg>
    );
};

export const GradedProjectIcon = () => {
    return (
        <svg
            width='54'
            height='54'
            viewBox='0 0 54 54'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.165713'
                d='M27 53.6104C41.6355 53.6104 53.5 41.7459 53.5 27.1104C53.5 12.4748 41.6355 0.610352 27 0.610352C12.3645 0.610352 0.5 12.4748 0.5 27.1104C0.5 41.7459 12.3645 53.6104 27 53.6104Z'
                fill='#79A342'
            />
            <path
                d='M37.5 18.5V20H35V22.5H33.5V20H31V18.5H33.5V16H35V18.5H37.5Z'
                fill='#79A342'
            />
            <path
                d='M22 31H34V26H36V31C36 32.1 35.1 33 34 33H22C20.9 33 20 32.1 20 31V19C20 17.9 20.9 17 22 17H27V19H22V31Z'
                fill='#79A342'
            />
            <path
                d='M16 21H18V35H32V37H18C16.9 37 16 36.1 16 35V21Z'
                fill='#79A342'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M25.5545 28.5L26.1818 27.0663H29.8181L30.4999 28.5H32.0272L28.5454 20.9999H27.4545L24.0272 28.5H25.5545ZM27.9999 22.3649L29.3599 25.8254H26.6399L27.9999 22.3649Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const WithdrawnProjectIcon = () => {
    return (
        <svg
            width='54'
            height='53'
            viewBox='0 0 54 53'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.5'
                d='M27 53C41.6355 53 53.5 41.1355 53.5 26.5C53.5 11.8645 41.6355 0 27 0C12.3645 0 0.5 11.8645 0.5 26.5C0.5 41.1355 12.3645 53 27 53Z'
                fill='#FECDC0'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M36.4269 18.1991L34.8925 16.3446C34.5945 15.9694 34.1419 15.7375 33.6231 15.7375H20.3771C19.8583 15.7375 19.4057 15.9694 19.0966 16.3446L17.5733 18.1991C17.2532 18.5745 17.0656 19.0712 17.0656 19.601V33.3989C17.0656 34.6132 18.059 35.6066 19.2733 35.6066H21.408V33.3989H19.2733V21.2567H34.7269V33.3989H32.7393V35.6066H34.7269C35.9412 35.6066 36.9346 34.6132 36.9346 33.3989V19.601C36.9346 19.0712 36.747 18.5745 36.4269 18.1991ZM20.642 17.9452H33.3582L34.2523 19.016H19.7589L20.642 17.9452Z'
                fill='#F5542F'
            />
            <path
                d='M25.3995 27.5355H28.6006V32.847H31.4154L27.0001 37.2624L22.5847 32.847H25.3995V27.5355Z'
                fill='#F5542F'
            />
            <g clipPath='url(#clip0)'>
                <path
                    d='M36.4267 18.527L34.8924 16.6725C34.5944 16.2972 34.1418 16.0654 33.623 16.0654H20.3769C19.8581 16.0654 19.4056 16.2972 19.0965 16.6725L17.5732 18.527C17.2531 18.9023 17.0654 19.399 17.0654 19.9289V33.7268C17.0654 34.9411 18.0589 35.9345 19.2731 35.9345H34.7268C35.9411 35.9345 36.9345 34.9411 36.9345 33.7268V19.9289C36.9345 19.399 36.7469 18.9023 36.4267 18.527ZM20.6419 18.2731H33.3581L34.2522 19.3438H19.7588L20.6419 18.2731ZM19.2731 33.7268V21.5846H34.7268V33.7268H19.2731Z'
                    fill='#C12743'
                />
                <rect
                    x='21.4078'
                    y='31.6858'
                    width='11.3313'
                    height='6.0564'
                    fill='#EDCDD4'
                />
                <path
                    d='M28.6005 27.8634H25.3994V33.1749H22.5846L27 37.5903L31.4153 33.1749H28.6005V27.8634Z'
                    fill='#C12743'
                />
            </g>
            <defs>
                <clipPath id='clip0'>
                    <rect
                        width='29'
                        height='29'
                        fill='white'
                        transform='translate(11.5 10.5)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TrendRedDownArrow = () => {
    return (
        <svg
            width='5'
            height='14'
            viewBox='0 0 5 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='mr-2'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5 10L2.5 14L0 10H2L2 0L3 0L3 10H5Z'
                fill='#C12743'
            />
        </svg>
    );
};

export const TrendGreenUpArrow = () => {
    return (
        <svg
            width='5'
            height='14'
            viewBox='0 0 5 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='mr-2'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5 4L2.5 0L0 4H2L2 14H3L3 4H5Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const SupervisorsIcon = () => {
    return (
        <svg
            width='21'
            height='16'
            viewBox='0 0 21 16'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M7.02535 9.93746C4.43469 9.93746 0 11.2328 0 13.8124V15.7498H14.0915V13.8124C14.0915 11.2328 9.61602 9.93746 7.02535 9.93746ZM2.59066 13.5356C3.52064 12.8935 5.04361 12.1517 7.02535 12.1517C9.0071 12.1517 10.5709 12.8935 11.5008 13.5356H2.59066ZM7.02535 8C9.1621 8 10.9003 6.26182 10.9003 4.12508C10.9003 1.98833 9.1621 0.250153 7.02535 0.250153C4.88861 0.250153 3.15043 1.98833 3.15043 4.12508C3.15043 6.26182 4.88861 8 7.02535 8ZM7.02535 2.46439C7.94426 2.46439 8.68603 3.20617 8.68603 4.12508C8.68603 5.04399 7.94426 5.78576 7.02535 5.78576C6.10644 5.78576 5.36467 5.04399 5.36467 4.12508C5.36467 3.20617 6.10644 2.46439 7.02535 2.46439ZM14.0915 10.0039C15.3758 10.9339 16.2615 12.1738 16.2615 13.8124V15.7498H20.6899V13.8124C20.6899 11.576 16.815 10.3028 14.0915 10.0039ZM13.6681 8C15.8048 8 17.543 6.26182 17.543 4.12508C17.543 1.98833 15.8048 0.250153 13.6681 0.250153C13.0702 0.250153 12.5167 0.394078 12.0074 0.637645C12.7049 1.62298 13.1145 2.82974 13.1145 4.12508C13.1145 5.42041 12.7049 6.62717 12.0074 7.61251C12.5167 7.85607 13.0702 8 13.6681 8Z' />
        </svg>
    );
};

export const SupervisorInsightsXButton = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='0.999999'
                y='0.999999'
                width='38'
                height='38'
                rx='19'
                transform='matrix(1 -5.26053e-07 -5.69765e-07 1 5.69764e-07 5.26053e-07)'
                fill='white'
                stroke='#DFE7F2'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M25.2562 27.3001L26.5381 26.0182L21.4561 20.9362L26.5381 15.8541L25.2562 14.5723L20.1742 19.6543L15.0921 14.5723L13.8103 15.8541L18.8923 20.9362L13.8103 26.0182L15.0921 27.3001L20.1742 22.218L25.2562 27.3001Z'
                fill='#35336C'
            />
        </svg>
    );
};
export const PencilGroupIcon: React.FC<IconProps> = ({ onClick }) => {
    return (
        <svg
            onClick={onClick}
            width='19'
            height='17'
            viewBox='0 0 19 17'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.5098 12.625L8.50977 16.625H18.5098V12.625H12.5098Z'
                fill='currentColor'
            />
            <path
                d='M9.56977 3.81543L0.509766 12.8754V16.6254H4.25977L13.3198 7.56543L9.56977 3.81543ZM3.42977 14.6254H2.50977V13.7054L9.56977 6.64543L10.4898 7.56543L3.42977 14.6254Z'
                fill='currentColor'
            />
            <path
                d='M16.2206 4.665C16.6106 4.275 16.6106 3.645 16.2206 3.255L13.8806 0.915C13.6806 0.715 13.4306 0.625 13.1706 0.625C12.9206 0.625 12.6606 0.725 12.4706 0.915C11.4599 1.92568 11.4599 3.56432 12.4706 4.575L12.5606 4.665C13.5713 5.67568 15.2099 5.67568 16.2206 4.665Z'
                fill='currentColor'
            />
        </svg>
    );
};

export const GradingBtnIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='30'
            height='31'
            viewBox='0 0 30 31'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M19.5285 1H6.69814C5.08098 1 3.75785 2.29907 3.75785 3.88683V14.8994H6.69814V3.88683H19.7958V8.48437H25.4091V14.8994H28.3493V9.66048L19.5285 1Z'
                fill='white'
            />
            <path
                d='M3.75785 26.9814V25.5914H6.69814V26.9814H25.4091V25.5914H28.3493V26.9814C28.3493 28.5692 27.0262 29.8683 25.4091 29.8683H6.68344C5.06628 29.8683 3.75785 28.5692 3.75785 26.9814Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.4498 13.8302H13.3398L12.7344 12.2065H9.73928L9.1445 13.8302H8.03459L10.7483 7.41504H11.7361L14.4498 13.8302ZM11.2422 8.75728L10.1429 11.1241H12.3415L11.2422 8.75728Z'
                fill='white'
            />
            <path
                d='M1.35088 23.1841C1.55974 23.3929 1.86049 23.5266 2.17795 23.5266L5.23561 23.5266V17.2609H2.17795C1.52632 17.2609 1 17.7872 1 19.3709L1 22.3487C1 22.6828 1.13367 22.9669 1.35088 23.1841Z'
                fill='white'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.02342 23.5266H26.4351L29.5679 20.3938L26.4351 17.2609H7.02342L7.02342 23.5266ZM9.38768 21.1624L9.38768 19.6252H25.4576L26.2262 20.3938L25.4576 21.1624H9.38768Z'
                fill='white'
            />
            <path
                d='M17.1837 8.52594H18.8971V9.45869H17.1837V11.1721H16.2509V9.45869H14.5376V8.52594H16.2509V6.81257H17.1837V8.52594Z'
                fill='white'
            />
            <path
                d='M19.5285 1H6.69814C5.08098 1 3.75785 2.29907 3.75785 3.88683V14.8994H6.69814V3.88683H19.7958V8.48437H25.4091V14.8994H28.3493V9.66048L19.5285 1Z'
                stroke='white'
                strokeWidth='0.3'
            />
            <path
                d='M3.75785 26.9814V25.5914H6.69814V26.9814H25.4091V25.5914H28.3493V26.9814C28.3493 28.5692 27.0262 29.8683 25.4091 29.8683H6.68344C5.06628 29.8683 3.75785 28.5692 3.75785 26.9814Z'
                stroke='white'
                strokeWidth='0.3'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.4498 13.8302H13.3398L12.7344 12.2065H9.73928L9.1445 13.8302H8.03459L10.7483 7.41504H11.7361L14.4498 13.8302ZM11.2422 8.75728L10.1429 11.1241H12.3415L11.2422 8.75728Z'
                stroke='white'
                strokeWidth='0.3'
            />
            <path
                d='M1.35088 23.1841C1.55974 23.3929 1.86049 23.5266 2.17795 23.5266L5.23561 23.5266V17.2609H2.17795C1.52632 17.2609 1 17.7872 1 19.3709L1 22.3487C1 22.6828 1.13367 22.9669 1.35088 23.1841Z'
                stroke='white'
                strokeWidth='0.3'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.02342 23.5266H26.4351L29.5679 20.3938L26.4351 17.2609H7.02342L7.02342 23.5266ZM9.38768 21.1624L9.38768 19.6252H25.4576L26.2262 20.3938L25.4576 21.1624H9.38768Z'
                stroke='white'
                strokeWidth='0.3'
            />
            <path
                d='M17.1837 8.52594H18.8971V9.45869H17.1837V11.1721H16.2509V9.45869H14.5376V8.52594H16.2509V6.81257H17.1837V8.52594Z'
                stroke='white'
                strokeWidth='0.3'
            />
        </svg>
    );
};

export const GradingArrowUp = ({ onClick }: IconProps) => {
    return (
        <svg
            onClick={onClick}
            width='13'
            height='9'
            viewBox='0 0 13 9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.54564 3.79219L11.4956 8.74219L12.9096 7.32819L6.54564 0.964188L0.181641 7.32819L1.59564 8.74219L6.54564 3.79219Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const HelpDocumentDownloadIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.4641 12.4277V15.6243H2.67791V12.4277H0.546875V15.6243C0.546875 16.7964 1.50584 17.7553 2.67791 17.7553H15.4641C16.6362 17.7553 17.5952 16.7964 17.5952 15.6243V12.4277H15.4641ZM14.3986 8.16566L12.8962 6.66328L10.1365 9.41232V0.707031H8.00551V9.41232L5.24581 6.66328L3.74343 8.16566L9.07102 13.4933L14.3986 8.16566Z'
                fill='currentColor'
            />
        </svg>
    );
};

export const InstructionTickIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='27'
            height='23'
            viewBox='0 0 27 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M22.2413 3.18375L23.8162 4.75875L9.48375 19.0913L3.18375 12.7913L4.75875 11.2163L9.48375 15.9413L22.2413 3.18375ZM22.2413 0L9.48375 12.7575L4.75875 8.0325L0 12.7913L9.48375 22.275L27 4.75875L22.2413 0Z'
                fill='#323232'
            />
        </svg>
    );
};

export const DepartmentIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='107'
            height='40'
            viewBox='0 0 107 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M93 10H81C79.9 10 79 10.9 79 12V28C79 29.1 79.9 30 81 30H93C94.1 30 95 29.1 95 28V12C95 10.9 94.1 10 93 10ZM84 12H86V17L85 16.25L84 17V12ZM93 28H81V12H82V21L85 18.75L88 21V12H93V28Z'
                fill='#79A342'
            />
            <circle opacity='0.1' cx='87' cy='20' r='20' fill='#79A342' />
            <line y1='21' x2='67' y2='21' stroke='#79A342' strokeWidth='2' />
        </svg>
    );
};

export const GreenTick: React.FC<IconProps> = () => {
    return (
        <svg
            width='13'
            height='10'
            viewBox='0 0 13 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='green-tick-icon'
        >
            <path
                d='M5.44398 9.44588C4.69274 10.1875 3.4792 10.1875 2.72796 9.43625L0.618711 7.327C0.0889909 6.79728 0.0986224 5.94009 0.647606 5.42963C1.16769 4.92881 1.99598 4.94807 2.49681 5.4489L4.08597 7.03806L10.2789 0.845145C10.799 0.325056 11.6369 0.325056 12.157 0.845145L12.1955 0.88367C12.7156 1.40376 12.7156 2.25131 12.1859 2.7714L5.44398 9.44588Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const BreadCrumbIcon = () => {
    return (
        <svg
            width='5'
            height='8'
            viewBox='0 0 5 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{ marginLeft: '10px', marginRight: '10px' }}
        >
            <path
                d='M1 1L3.66667 3.66667L1 6.33333'
                stroke='#95AAC9'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const IndividualFormat = () => {
    return (
        <svg
            width='15'
            height='15'
            viewBox='0 0 15 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.22563 8.3655C4.88381 8.3655 0.22563 9.65096 0.22563 12.1837V14.0928H14.2256V12.1837C14.2256 9.65096 9.56745 8.3655 7.22563 8.3655ZM8.76563 6.04914C9.7329 5.50186 10.4074 4.47096 10.4074 3.27459C10.4074 1.51823 8.98199 0.0927734 7.22563 0.0927734C5.46927 0.0927734 4.04381 1.51823 4.04381 3.27459C4.04381 4.47096 4.71836 5.50186 5.68563 6.04914C6.14381 6.30368 6.66563 6.45641 7.22563 6.45641C7.78563 6.45641 8.30745 6.30368 8.76563 6.04914Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const GroupFormat = () => {
    return (
        <svg
            width='21'
            height='14'
            viewBox='0 0 21 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.04858 7C8.97858 7 10.5486 5.43 10.5486 3.5C10.5486 1.57 8.97858 0 7.04858 0C5.11858 0 3.54858 1.57 3.54858 3.5C3.54858 5.43 5.11858 7 7.04858 7ZM7.04858 2C7.87858 2 8.54858 2.67 8.54858 3.5C8.54858 4.33 7.87858 5 7.04858 5C6.21858 5 5.54858 4.33 5.54858 3.5C5.54858 2.67 6.21858 2 7.04858 2ZM7.09858 12H2.81858C3.80858 11.5 5.51858 11 7.04858 11C7.15858 11 7.27858 11.01 7.38858 11.01C7.72858 10.28 8.31858 9.68 9.02858 9.2C8.29858 9.07 7.60858 9 7.04858 9C4.70858 9 0.048584 10.17 0.048584 12.5V14H7.04858V12.5C7.04858 12.33 7.06858 12.16 7.09858 12ZM14.5486 9.5C12.7086 9.5 9.04858 10.51 9.04858 12.5V14H20.0486V12.5C20.0486 10.51 16.3886 9.5 14.5486 9.5ZM15.7586 7.68C16.5186 7.25 17.0486 6.44 17.0486 5.5C17.0486 4.12 15.9286 3 14.5486 3C13.1686 3 12.0486 4.12 12.0486 5.5C12.0486 6.44 12.5786 7.25 13.3386 7.68C13.6986 7.88 14.1086 8 14.5486 8C14.9886 8 15.3986 7.88 15.7586 7.68Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const GroupIndividualFormat = () => {
    return (
        <svg
            width='21'
            height='14'
            viewBox='0 0 21 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.04858 7C8.97858 7 10.5486 5.43 10.5486 3.5C10.5486 1.57 8.97858 0 7.04858 0C5.11858 0 3.54858 1.57 3.54858 3.5C3.54858 5.43 5.11858 7 7.04858 7ZM7.04858 2C7.87858 2 8.54858 2.67 8.54858 3.5C8.54858 4.33 7.87858 5 7.04858 5C6.21858 5 5.54858 4.33 5.54858 3.5C5.54858 2.67 6.21858 2 7.04858 2ZM7.09858 12H2.81858C3.80858 11.5 5.51858 11 7.04858 11C7.15858 11 7.27858 11.01 7.38858 11.01C7.72858 10.28 8.31858 9.68 9.02858 9.2C8.29858 9.07 7.60858 9 7.04858 9C4.70858 9 0.048584 10.17 0.048584 12.5V14H7.04858V12.5C7.04858 12.33 7.06858 12.16 7.09858 12ZM14.5486 9.5C12.7086 9.5 9.04858 10.51 9.04858 12.5V14H20.0486V12.5C20.0486 10.51 16.3886 9.5 14.5486 9.5ZM15.7586 7.68C16.5186 7.25 17.0486 6.44 17.0486 5.5C17.0486 4.12 15.9286 3 14.5486 3C13.1686 3 12.0486 4.12 12.0486 5.5C12.0486 6.44 12.5786 7.25 13.3386 7.68C13.6986 7.88 14.1086 8 14.5486 8C14.9886 8 15.3986 7.88 15.7586 7.68Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const HistoryIcon = () => {
    return (
        <svg
            width='12'
            height='15'
            viewBox='0 0 12 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.9'
                d='M6.02423 3.61502V0.843262L2.55953 4.30796L6.02423 7.77265V5.0009C8.31785 5.0009 10.1819 6.8649 10.1819 9.15853C10.1819 11.4522 8.31785 13.3162 6.02423 13.3162C3.7306 13.3162 1.86659 11.4522 1.86659 9.15853H0.480713C0.480713 12.2213 2.96144 14.702 6.02423 14.702C9.08702 14.702 11.5677 12.2213 11.5677 9.15853C11.5677 6.09574 9.08702 3.61502 6.02423 3.61502Z'
                fill='#31417A'
            />
        </svg>
    );
};

export const DataProtectionIcon: React.FC<IconProps> = () => {
    return (
        <svg
            width='16'
            height='19'
            viewBox='0 0 16 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8 0L0 3.45455V8.63636C0 13.4295 3.41333 17.9118 8 19C12.5867 17.9118 16 13.4295 16 8.63636V3.45455L8 0ZM14.2222 8.63636C14.2222 12.54 11.5733 16.1414 8 17.2123C4.42667 16.1414 1.77778 12.54 1.77778 8.63636V4.57727L8 1.89136L14.2222 4.57727V8.63636ZM3.92 9.14591L2.66667 10.3636L6.22222 13.8182L13.3333 6.90909L12.08 5.68273L6.22222 11.3741L3.92 9.14591Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const TrashCanIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='13'
            height='15'
            fill='none'
        >
            <path
                fill='#1F2756'
                d='M9.8 5.265v7.778H2.4V5.265h7.4ZM8.6.598h-5l-.8.778H0V2.93h12.2V1.376H9.4L8.6.598Zm2.8 3.111H.8v9.334c0 .855.72 1.555 1.6 1.555h7.4c.88 0 1.6-.7 1.6-1.555V3.709Z'
            />
        </svg>
    );
};

export const DuplicateClipboardIcon = () => {
    return (
        <svg
            width='14'
            height='17'
            viewBox='0 0 14 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.15679 6.69737H7.62684V9.14182H10.0884V10.6418H7.62684V13.0863H6.15679V10.6418H3.6952V9.14182H6.15679V6.69737Z'
                fill='#95AAC9'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.82693 1.95161H13.4046C13.4046 1.95161 13.4046 2.60612 13.4046 3.40614V15.4419C13.4046 16.2419 13.4046 16.8965 13.4046 16.8965H0.0713409C0.0713409 16.8965 0.0712891 16.2419 0.0712891 15.4419V1.95161C0.0712891 1.95161 0.737956 1.95161 1.55284 1.95161H4.64898C4.96018 1.10796 5.77506 0.49707 6.73796 0.49707C7.70085 0.49707 8.51573 1.10796 8.82693 1.95161ZM7.47862 2.67893C7.47862 2.27886 7.14529 1.95161 6.73796 1.95161C6.33062 1.95161 5.99729 2.27886 5.99729 2.67893C5.99729 3.07888 6.33062 3.40614 6.73796 3.40614C7.14529 3.40614 7.47862 3.07888 7.47862 2.67893ZM1.55284 3.40614V15.4419H11.9231V3.40614H10.4417V4.69911H3.03418V3.40614H1.55284Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const SelectCaretDownIcon = () => {
    return (
        <svg
            width='12'
            height='6'
            viewBox='0 0 12 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.9258 0.415039L6.42578 5.83319L0.925781 0.415051L11.9258 0.415039Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const ClearIndicatorIcon = () => {
    return (
        <svg
            width='11'
            height='12'
            viewBox='0 0 11 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.5809 10.2211L9.52946 11.2726L5.36091 7.10404L1.19237 11.2726L0.140915 10.2211L4.30946 6.05258L0.140915 1.88404L1.19237 0.832583L5.36091 5.00113L9.52946 0.832583L10.5809 1.88404L6.41237 6.05258L10.5809 10.2211Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const DownloadBtnIcon = () => {
    return (
        <svg
            id='download-btn-icon'
            width='12'
            height='20'
            viewBox='0 0 12 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M4.55013 8.02486V0.947266H7.08181V8.02486H11.5122L5.81597 13.7224L0.119678 8.02486H4.55013Z' />
            <path d='M8.99404 17.1693H2.32263V19.9387H8.99404V17.1693Z' />
        </svg>
    );
};

export const DownloadReportDropdownIcon = () => {
    return (
        <svg
            width='9'
            height='5'
            viewBox='0 0 9 5'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.49609 0.535112C8.49609 0.260025 8.27609 0.0438843 7.99609 0.0438843H0.996094C0.716094 0.0438843 0.496094 0.260025 0.496094 0.535112C0.496094 0.662832 0.546094 0.770902 0.626094 0.859323V0.859323L4.12609 4.78915V4.78915C4.21609 4.88739 4.34609 4.95617 4.49609 4.95617C4.64609 4.95617 4.77609 4.88739 4.86609 4.78915V4.78915L8.36609 0.859323V0.859323C8.44609 0.770902 8.49609 0.662832 8.49609 0.535112Z'
                fill='white'
            />
        </svg>
    );
};

export const WhiteTrianglePointingUp = () => {
    return (
        <svg
            width='9'
            height='5'
            viewBox='0 0 9 5'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.673828 4.53955L4.67383 0.539551L8.67383 4.53955H0.673828Z'
                fill='white'
            />
        </svg>
    );
};

export const DownloadReportBtnIcon = () => {
    return (
        <svg
            width='10'
            height='16'
            viewBox='0 0 10 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.07812 5.62906V0.0390625H6.07812V5.62906H9.57812L5.07812 10.1291L0.578125 5.62906H4.07812Z'
                fill='#95AAC9'
            />
            <path
                d='M9.57812 15.0391V12.8518H0.578125V15.0391H9.57812Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const CreditCardIcon = () => (
    <svg
        width='32'
        height='34'
        viewBox='0 0 32 34'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18 0H2C0.890015 0 0.0100098 0.834351 0.0100098 1.875L0 13.125C0 14.1656 0.890015 15 2 15H5V13.125H2V7.5H20V1.875C20 0.834351 19.11 0 18 0ZM18 3.75H2V1.875H18V3.75Z'
            fill='#323232'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8 11H24C25.11 11 26 11.8344 26 12.875V18.5H8V24.125H16V26H8C6.89001 26 6 25.1656 6 24.125L6.01001 12.875C6.01001 11.8344 6.89001 11 8 11ZM8 14.75H24V12.875H8V14.75Z'
            fill='#323232'
        />
        <path
            d='M25.1248 34H27.8748V29.875H31.9998V27.125H27.8748V23H25.1248V27.125H20.9998V29.875H25.1248V34Z'
            fill='#323232'
        />
    </svg>
);
export const SaveSvg = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V4L14 0ZM16 16H2V2H13.17L16 4.83V16ZM9 9C7.34 9 6 10.34 6 12C6 13.66 7.34 15 9 15C10.66 15 12 13.66 12 12C12 10.34 10.66 9 9 9ZM3 3H12V7H3V3Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const BillingDetailsSvg = () => (
    <svg
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M2.8421 23.9191V2.7207H22.7368V10.8826H25.5789V2.7207C25.5789 1.22424 24.3 0 22.7368 0H2.8421C1.27893 0 0 1.22424 0 2.7207V23.9191C0 25.4154 1.27893 26.6396 2.8421 26.6396H11.3684V23.9191H2.8421Z'
            fill='#323232'
        />
        <path
            d='M23.8748 28H21.1248V23.875H16.9998V21.125H21.1248V17H23.8748V21.125H27.9998V23.875H23.8748V28Z'
            fill='#323232'
        />
        <path
            d='M13.8021 19.2693H11.4016V18.0424H9.0011V15.5885H13.8021V14.3616H10.2013C9.5412 14.3616 9.0011 13.8094 9.0011 13.1346V9.45386C9.0011 8.77905 9.5412 8.22693 10.2013 8.22693H11.4016V7H13.8021V8.22693H16.2026V10.6808H11.4016V11.9077H15.0023C15.6625 11.9077 16.2026 12.4598 16.2026 13.1346V16.8154C16.2026 17.4902 15.6625 18.0424 15.0023 18.0424H13.8021V19.2693Z'
            fill='#323232'
        />
    </svg>
);

export const PrintIcon = () => {
    return (
        <svg
            width='16'
            height='14'
            viewBox='0 0 16 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.6 3.88889H12.8V0H3.2V3.88889H2.4C1.072 3.88889 0 4.93111 0 6.22222V10.8889H3.2V14H12.8V10.8889H16V6.22222C16 4.93111 14.928 3.88889 13.6 3.88889ZM4.8 1.55556H11.2V3.88889H4.8V1.55556ZM11.2 10.8889V12.4444H4.8V9.33333H11.2V10.8889ZM12.8 9.33333V7.77778H3.2V9.33333H1.6V6.22222C1.6 5.79444 1.96 5.44444 2.4 5.44444H13.6C14.04 5.44444 14.4 5.79444 14.4 6.22222V9.33333H12.8Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const DuplicateCateriaIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.64774 2.18465V11.191H10.6541V2.18465H1.64774ZM1.64774 0.683594H10.6541C11.4796 0.683594 12.1551 1.35907 12.1551 2.18465V11.191C12.1551 12.0166 11.4796 12.692 10.6541 12.692H1.64774C0.822161 12.692 0.146688 12.0166 0.146688 11.191V2.18465C0.146688 1.35907 0.822161 0.683594 1.64774 0.683594ZM13.6562 3.6857H15.1572V14.1931C15.1572 15.0187 14.4818 15.6941 13.6562 15.6941H3.1488V14.1931H13.6562V3.6857Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const DeleteCateriaIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.7188 5.9023C15.5313 5.2226 15.2598 4.5781 14.9063 3.9687C14.5567 3.3808 14.1368 2.8417 13.6485 2.3515C13.1583 1.8622 12.6192 1.4433 12.0313 1.0937C11.4219 0.7397 10.7774 0.4687 10.0977 0.2812C9.418 0.0937 8.7188 0 8 0C7.2812 0 6.582 0.0952 5.9023 0.2852C5.2226 0.4756 4.58 0.7452 3.9765 1.0938C3.3827 1.4434 2.8398 1.8624 2.3515 2.3516C1.8613 2.8418 1.4453 3.3809 1.1015 3.9688C0.7465 4.5733 0.475 5.2168 0.2851 5.8985C0.0947 6.5811 0 7.2812 0 8C0 8.7188 0.0947 9.418 0.2852 10.0977C0.4751 10.7774 0.7466 11.42 1.1016 12.0235C1.4454 12.6173 1.8614 13.1592 2.3516 13.6485C2.8399 14.1387 3.3828 14.5547 3.9766 14.8985C4.5801 15.253 5.2227 15.5245 5.9024 15.7149C6.5821 15.9053 7.2812 16 8 16C8.7188 16 9.418 15.9053 10.1016 15.7148C10.7832 15.5244 11.4258 15.2529 12.0313 14.8984C12.6192 14.5546 13.1583 14.1386 13.6485 13.6484C14.1368 13.1591 14.5567 12.6172 14.9063 12.0234C15.254 11.4199 15.5235 10.7773 15.7149 10.0976C15.9043 9.418 16 8.7188 16 8C16 7.2812 15.9062 6.582 15.7188 5.9023ZM14.1743 9.6871C14.0238 10.2317 13.806 10.7435 13.5209 11.2237C12.9506 12.1851 12.1842 12.9504 11.2238 13.5207C10.7426 13.8059 10.2297 14.0237 9.6872 14.1742C9.1426 14.3247 8.5802 14.4 8 14.4C7.4178 14.4 6.8555 14.3247 6.3129 14.1743C5.7683 14.0238 5.2555 13.806 4.7763 13.5208C3.8139 12.9505 3.0496 12.1852 2.4792 11.2238C2.194 10.7436 1.9763 10.2317 1.8258 9.6872C1.6752 9.1436 1.6 8.5812 1.6 8C1.6 7.4198 1.6753 6.8574 1.8258 6.3129C1.9763 5.7693 2.1941 5.2574 2.4792 4.7763C3.0495 3.8159 3.8139 3.0496 4.7763 2.4792C5.2555 2.194 5.7684 1.9762 6.3129 1.8258C6.8555 1.6752 7.4178 1.6 8 1.6C8.5802 1.6 9.1426 1.6753 9.6871 1.8258C10.2296 1.9763 10.7425 2.1941 11.2237 2.4792C12.1841 3.0495 12.9504 3.8158 13.5208 4.7763C13.806 5.2574 14.0237 5.7693 14.1742 6.3129C14.3248 6.8574 14.4 7.4198 14.4 8C14.4 8.5812 14.3248 9.1436 14.1743 9.6871ZM9.0971 7.9656L10.9314 6.1313L9.8 5L7.9657 6.8343L6.1314 5L5 6.1313L6.8344 7.9656L5 9.8L6.1314 10.9313L7.9657 9.097L9.8 10.9313L10.9314 9.8L9.0971 7.9656Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const FoldedTreeIcon: React.FC<IconProps> = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-chevron-right'
            viewBox='0 0 16 16'
        >
            <path
                fillRule='evenodd'
                d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'
            />
        </svg>
    );
};

export const UnfoldedTreeIcon: React.FC<IconProps> = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='currentColor'
            className='bi bi-chevron-down'
            viewBox='0 0 16 16'
        >
            <path
                fillRule='evenodd'
                d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'
            />
        </svg>
    );
};

export const SignOutIcon = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.9'
                d='M6.5249 15.5482C7.29475 15.8401 8.12904 16 8.99998 16C9.03876 16 9.07748 15.9996 9.11611 15.999C10.4934 15.9744 11.8299 15.541 12.9544 14.7734C14.0473 14.0226 14.9173 12.9696 15.4431 11.7361C15.4669 11.6801 15.49 11.6237 15.5124 11.5667C15.5337 11.5126 15.5547 11.4586 15.5746 11.4044C15.8497 10.6543 16 9.84436 16 9C16 8.94104 15.9993 8.8822 15.9978 8.82361C15.9623 7.4845 15.5408 6.18677 14.8019 5.08752C14.0302 3.94678 12.9313 3.04468 11.6409 2.51709C11.6165 2.5072 11.5913 2.49707 11.5668 2.48743C11.5127 2.46619 11.4587 2.44531 11.4044 2.42542C10.6543 2.15027 9.84436 2 8.99998 2C8.91637 2 8.83309 2.00146 8.75018 2.00439C7.43636 2.0531 6.16554 2.47278 5.08595 3.19897C4.05324 3.89795 3.21625 4.86523 2.67585 6H0.514709C0.896149 4.92529 1.47644 3.9436 2.21104 3.09961L2.20578 3.09753C2.71968 2.50745 3.30403 1.9928 3.94133 1.56104C5.38418 0.576416 7.12644 0 8.99998 0C10.164 0 11.2778 0.222168 12.3001 0.626831C14.0493 1.31628 15.4624 2.49683 16.4441 3.94897C17.4256 5.39038 18 7.12976 18 9C18 10.1637 17.7776 11.2769 17.3731 12.299V12.3C16.6875 14.0396 15.5161 15.4467 14.0749 16.4277C12.6289 17.4192 10.8805 18 8.99998 18C7.83621 18 6.72309 17.7777 5.70093 17.3732L5.69988 17.373C3.9603 16.6874 2.55324 15.5161 1.5722 14.075C1.13496 13.4373 0.777603 12.7407 0.514709 12H0.520378C0.269676 11.293 0.106178 10.5538 0.0374527 9.80005H0V8.19995H9.74286L7.51428 6.12L8.71429 5L13 9L8.71429 13L7.51428 11.88L9.74286 9.80005H2.04678C2.17892 10.9321 2.58599 12.0156 3.22524 12.9525C3.96302 14.0271 4.99265 14.8864 6.19888 15.415C6.27615 15.4487 6.35419 15.4812 6.43324 15.5123C6.46382 15.5244 6.49426 15.5366 6.5249 15.5482Z'
                fill='#131E4A'
            />
        </svg>
    );
};

export const ArrowDownIcon = () => (
    <svg
        width='9'
        height='7'
        viewBox='0 0 9 7'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M1.28505 6.25195L4.56226 2.98188L7.83948 6.25195L8.84621 5.24523L4.56226 0.961282L0.27832 5.24523L1.28505 6.25195Z'
            fill='#95AAC9'
        />
    </svg>
);

export const ArrowDownIcon2 = () => (
    <svg width='13' height='8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M6.364 4.95 11.314 0l1.414 1.414-6.364 6.364L0 1.414 1.414 0l4.95 4.95Z'
            fill='#1F2756'
        />
    </svg>
);

export const GreenCircleTick = () => (
    <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M10.9424 0.109375C5.04465 0.109375 0.258057 4.89597 0.258057 10.7937C0.258057 16.6915 5.04465 21.4781 10.9424 21.4781C16.8402 21.4781 21.6268 16.6915 21.6268 10.7937C21.6268 4.89597 16.8402 0.109375 10.9424 0.109375ZM8.80555 16.1359L3.46337 10.7937L4.96986 9.28724L8.80555 13.1122L16.915 5.00281L18.4215 6.51999L8.80555 16.1359Z'
            fill='#79A342'
        />
    </svg>
);

export const ExpectedWorkIcon = () => (
    <svg
        width='16'
        height='17'
        viewBox='0 0 16 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.90796 0.832031C4.13434 0.832031 3.50739 1.46027 3.49847 2.23181C3.49628 2.26495 3.49512 2.29834 3.49512 2.33203L3.49316 10.5547H3.49512V12.332C3.49512 13.157 4.1701 13.832 4.99512 13.832H13.9951C14.8201 13.832 15.4951 13.157 15.4951 12.332L15.495 5.08203L11.245 0.832031H4.90796ZM10.5367 2.33203H4.99512V12.332H13.9951V5.79034H10.5367V2.33203Z'
            fill='#95AAC9'
        />
        <path
            d='M1.99512 3.83203H0.495117V15.332C0.495117 16.157 1.1701 16.832 1.99512 16.832H12.4951V15.332H1.99512V3.83203Z'
            fill='#95AAC9'
        />
    </svg>
);

export const ProjectTypeVisibility = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='13' fill='none'>
        <path
            fill='#1F2756'
            d='M7.333 2.598c2.527 0 4.78 1.42 5.88 3.666a6.43 6.43 0 0 1-1.606 2.08l.94.94a7.869 7.869 0 0 0 2.12-3.02c-1.154-2.926-4-5-7.334-5a7.9 7.9 0 0 0-2.426.38l1.1 1.1a6.738 6.738 0 0 1 1.326-.146Zm-.713.76L8 4.738c.38.166.687.473.853.853l1.38 1.38c.054-.227.094-.467.094-.713a2.989 2.989 0 0 0-2.994-2.994c-.246 0-.48.034-.713.094ZM.673 1.178 2.46 2.964A7.825 7.825 0 0 0 0 6.264c1.153 2.927 4 5 7.333 5a7.818 7.818 0 0 0 2.88-.546l2.28 2.28.94-.94L1.613.23l-.94.947Zm5 5 1.74 1.74a.334.334 0 0 1-.08.013c-.92 0-1.666-.747-1.666-1.667 0-.033.006-.053.006-.086ZM3.407 3.91l1.166 1.167a3.005 3.005 0 0 0 3.94 3.947l.654.653c-.587.16-1.2.253-1.834.253a6.513 6.513 0 0 1-5.88-3.667 6.601 6.601 0 0 1 1.954-2.353Z'
        />
    </svg>
);

export const ProjectTypeVisibilityOff = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='12' fill='none'>
        <path
            fill='#1F2756'
            d='M7.503 1.851c2.584 0 4.889 1.562 6.014 4.033-1.125 2.472-3.423 4.034-6.014 4.034S2.614 8.356 1.489 5.884c1.125-2.471 3.43-4.033 6.014-4.033Zm0-1.467c-3.41 0-6.32 2.281-7.5 5.5 1.18 3.22 4.09 5.5 7.5 5.5 3.409 0 6.32-2.28 7.5-5.5-1.18-3.219-4.091-5.5-7.5-5.5Zm0 3.667c.94 0 1.704.821 1.704 1.833s-.763 1.834-1.704 1.834-1.705-.822-1.705-1.834.764-1.833 1.705-1.833Zm0-1.467c-1.691 0-3.068 1.482-3.068 3.3 0 1.819 1.377 3.3 3.068 3.3 1.69 0 3.068-1.481 3.068-3.3 0-1.818-1.377-3.3-3.068-3.3Z'
        />
    </svg>
);

export const PlusWithCircleIcon = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.5398 1.55566C10.8627 1.36296 10.157 1.2666 9.42261 1.2666C8.69344 1.2666 7.98771 1.36296 7.30542 1.55566C6.62834 1.74837 5.99292 2.01921 5.39917 2.36816C4.80542 2.71712 4.26375 3.13639 3.77417 3.62598C3.28979 4.11035 2.87313 4.64941 2.52417 5.24316C2.17521 5.83691 1.90438 6.47494 1.71167 7.15723C1.51896 7.83431 1.42261 8.53744 1.42261 9.2666C1.42261 9.99577 1.51896 10.7015 1.71167 11.3838C1.90438 12.0609 2.17521 12.6963 2.52417 13.29C2.87313 13.8838 3.28979 14.4255 3.77417 14.915C4.26375 15.3994 4.80542 15.8161 5.39917 16.165C5.99292 16.514 6.62834 16.7848 7.30542 16.9775C7.98771 17.1702 8.69344 17.2666 9.42261 17.2666C10.1518 17.2666 10.8549 17.1702 11.532 16.9775C12.2143 16.7848 12.8523 16.514 13.446 16.165C14.0398 15.8161 14.5789 15.3994 15.0632 14.915C15.5528 14.4255 15.9721 13.8838 16.321 13.29C16.67 12.6963 16.9408 12.0609 17.1335 11.3838C17.3263 10.7015 17.4226 9.99577 17.4226 9.2666C17.4226 8.53223 17.3263 7.8265 17.1335 7.14941C16.9408 6.47233 16.67 5.83691 16.321 5.24316C15.9721 4.64941 15.5528 4.11035 15.0632 3.62598C14.5789 3.13639 14.0398 2.71712 13.446 2.36816C12.8523 2.01921 12.2169 1.74837 11.5398 1.55566Z'
                stroke='#31417A'
            />
            <path
                d='M8.76217 5.97754V8.60354H6.14917V9.92954H8.76217V12.5555H10.0882V9.92954H12.7012V8.60354H10.0882V5.97754H8.76217Z'
                fill='#31417A'
            />
        </svg>
    );
};
export const FullScreenIcon = () => (
    <svg
        width='15'
        height='14'
        viewBox='0 0 15 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M8.84486 5.27592L13.0103 1.09766'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.69718 0.691406H13.4165V4.41073'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.87549 8.14648L1.55855 12.5754'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.04736 12.7779H1.32804V9.05859'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.91379 5.27658L1.32861 0.691406'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M5.04794 0.691406H1.32861V4.41073'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M8.84619 8.12109L13.4184 12.7765'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.69775 12.7779H13.4171V9.05859'
            stroke='#98A0BD'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export const MinimizeFullScreenGradingIcon = () => (
    <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            x='1.49609'
            y='1.36328'
            width='11.5068'
            height='11.1966'
            rx='1'
            stroke='#98A0BD'
            strokeWidth='1.2'
        />
        <path
            d='M4.26925 8.9862L1.09047 12.2096L2.0953 13.2144L5.27407 9.99103L6.59038 11.1658L6.77629 7.48399L3.07316 7.79207L4.26925 8.9862Z'
            fill='#98A0BD'
        />
        <path
            d='M8.93542 4.29659L12.1588 1.11782L13.1637 2.12264L9.94025 5.30142L11.115 6.61773L7.43321 6.80363L7.74129 3.10051L8.93542 4.29659Z'
            fill='#98A0BD'
        />
    </svg>
);

export const BoldXIcon = () => (
    <svg
        width='13'
        height='14'
        viewBox='0 0 13 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            opacity='0.5'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.64495 5.63799L2.28986 1.28291C1.85211 0.845152 1.13374 0.856376 0.695991 1.28291C0.258238 1.72066 0.258238 2.4278 0.695991 2.86555L5.10504 7.2746L0.695991 11.6837C0.258238 12.1214 0.258238 12.8285 0.695991 13.2663C1.13374 13.6928 1.85211 13.7041 2.28986 13.2663L6.64495 8.91121L11 13.2663C11.4378 13.7041 12.1449 13.7041 12.5827 13.2663C13.0204 12.8285 13.0204 12.1214 12.5827 11.6837L8.17364 7.2746L12.5827 2.86555C13.0204 2.4278 13.0204 1.72066 12.5827 1.28291C12.1449 0.845151 11.4378 0.845151 11 1.28291L6.64495 5.63799Z'
            fill='#31417A'
        />
    </svg>
);

export const GradingArrowDown = ({ onClick }: IconProps) => (
    <svg
        onClick={onClick}
        width='14'
        height='9'
        viewBox='0 0 14 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M7.32738 5.50225L12.2774 0.552246L13.6914 1.96625L7.32738 8.33025L0.963379 1.96625L2.37738 0.552246L7.32738 5.50225Z'
            fill='#95AAC9'
        />
    </svg>
);

export const IncompleteGradingTabIcon = () => {
    return (
        <svg
            width='20'
            height='21'
            viewBox='0 0 20 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='draft-grading-icon'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.95665 2.96939C5.80808 2.96939 2.49575 6.28171 2.49575 10.4303C2.49575 14.5788 5.80808 17.8912 9.95665 17.8912C14.1052 17.8912 17.4175 14.5788 17.4175 10.4303C17.4175 6.28171 14.1052 2.96939 9.95665 2.96939ZM0.00878906 10.4303C0.00878906 4.93623 4.4626 0.482422 9.95665 0.482422C15.4507 0.482422 19.9045 4.93623 19.9045 10.4303C19.9045 15.9243 15.4507 20.3781 9.95665 20.3781C4.4626 20.3781 0.00878906 15.9243 0.00878906 10.4303Z'
                fill='#EBF0F7'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.4189 10.4303C17.4189 6.30974 14.0785 2.96939 9.95801 2.96939V0.482422C15.4521 0.482422 19.9059 4.93623 19.9059 10.4303H17.4189Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const GradingEmptyCircleIcon = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='empty-grading-icon'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.2475 19.5926C15.5494 19.5926 19.8475 15.2945 19.8475 9.99258C19.8475 4.69064 15.5494 0.392578 10.2475 0.392578C4.94553 0.392578 0.647461 4.69064 0.647461 9.99258C0.647461 15.2945 4.94553 19.5926 10.2475 19.5926ZM10.2475 18.3926C5.60827 18.3926 1.84746 14.6318 1.84746 9.99258C1.84746 5.35339 5.60827 1.59258 10.2475 1.59258C14.8867 1.59258 18.6475 5.35339 18.6475 9.99258C18.6475 14.6318 14.8867 18.3926 10.2475 18.3926Z'
                fill='#B8C8DE'
            />
        </svg>
    );
};

export const CompletedGradingCircleIcon = () => {
    return (
        <svg
            width='21'
            height='21'
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='completed-grading-icon'
        >
            <circle cx='10.3884' cy='10.1882' r='9.94799' fill='#79A342' />
            <path
                d='M9.272 14.1612L5.4502 10.3866L6.4882 9.34855L9.272 12.1795L14.8868 6.51758L15.9248 7.55561L9.272 14.1612Z'
                fill='white'
            />
        </svg>
    );
};

export const CollapseAllGradingIcon = () => {
    return (
        <svg
            width='9'
            height='15'
            viewBox='0 0 9 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.44867 2.69028L7.68026 5.92187L8.60338 4.99875L4.44867 0.844029L0.293945 4.99875L1.21707 5.92188L4.44867 2.69028Z'
                fill='#95AAC9'
            />
            <path
                d='M4.44867 12.6183L7.68026 9.38672L8.60338 10.3098L4.44867 14.4646L0.293945 10.3098L1.21707 9.38672L4.44867 12.6183Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const UnlockIcon = () => {
    return (
        <svg
            width='14'
            height='19'
            viewBox='0 0 14 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.375 6.34375H12.25C13.2125 6.34375 14 7.13124 14 8.09374V16.8437C14 17.8062 13.2125 18.5937 12.25 18.5937H1.75001C0.787512 18.5937 1.23978e-05 17.8062 1.23978e-05 16.8437V8.09374C1.23978e-05 7.13124 0.787512 6.34375 1.75001 6.34375H9.00001V4.59375C9.00001 3.5 8.45251 2.5 7.00001 2.5C6.0675 2.5 5.50801 2.91216 5.22692 3.49669H2.76388C3.2511 1.61208 4.96383 0.21875 7.00001 0.21875C9.415 0.21875 11.375 2.17875 11.375 4.59375V6.34375ZM2.00001 16.5H12V8.5H2.00001V16.5Z'
                fill='#35336C'
            />
        </svg>
    );
};

export const InfoTooltipIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            fill='none'
        >
            <path
                fill='#1F2756'
                fillRule='evenodd'
                d='M6.735 1.477a5.281 5.281 0 1 0 0 10.563 5.281 5.281 0 0 0 0-10.563ZM.235 6.76a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Zm5.282-.203a.61.61 0 0 1 .609-.61h.812a.61.61 0 0 1 .61.61V8.79h.203a.61.61 0 0 1 0 1.219H6.126a.61.61 0 0 1 0-1.22h.203V7.166h-.203a.61.61 0 0 1-.61-.61Zm1.218-1.422a.813.813 0 1 0 0-1.625.813.813 0 0 0 0 1.625Z'
                clipRule='evenodd'
            />
        </svg>
    );
};

export const SupervisorCapacityIcon = () => {
    return (
        <svg
            width='18'
            height='22'
            viewBox='0 0 18 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.2 3.66667H1.8C0.81 3.66667 0 4.49167 0 5.5V16.5C0 17.5083 0.81 18.3333 1.8 18.3333H16.2C17.19 18.3333 18 17.5083 18 16.5V5.5C18 4.49167 17.19 3.66667 16.2 3.66667ZM16.2 16.5H1.8V5.5H16.2V16.5ZM1.8 0H16.2V1.83333H1.8V0ZM1.8 20.1667H16.2V22H1.8V20.1667ZM9 11C10.242 11 11.25 9.97333 11.25 8.70833C11.25 7.44333 10.242 6.41667 9 6.41667C7.758 6.41667 6.75 7.44333 6.75 8.70833C6.75 9.97333 7.758 11 9 11ZM9 7.79167C9.495 7.79167 9.9 8.20417 9.9 8.70833C9.9 9.2125 9.495 9.625 9 9.625C8.505 9.625 8.1 9.2125 8.1 8.70833C8.1 8.20417 8.505 7.79167 9 7.79167ZM13.5 14.6575C13.5 12.7417 10.521 11.9167 9 11.9167C7.479 11.9167 4.5 12.7417 4.5 14.6575V15.5833H13.5V14.6575ZM6.129 14.2083C6.678 13.7317 7.956 13.2917 9 13.2917C10.053 13.2917 11.331 13.7317 11.88 14.2083H6.129Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const SidebarSupervisorPublishedResearchAreasIcon = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.2 0H1.8C0.81 0 0 0.81 0 1.8V18L3.6 14.4H16.2C17.19 14.4 18 13.59 18 12.6V1.8C18 0.81 17.19 0 16.2 0ZM16.2 12.6H2.853L1.8 13.653V1.8H16.2V12.6Z'
                fill='#95AAC9'
            />
            <path
                d='M8.14 10.6382L13.7406 5.00665L12.7394 4L8.14 8.62488L6.14722 6.62108L5.14611 7.62773L8.14 10.6382Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const ProjectTopicMessageIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='23'
            height='23'
            fill='none'
        >
            <path
                fill='#fff'
                fillRule='evenodd'
                d='M14.056.035a3.265 3.265 0 0 1 3.265 3.266v1.28h3.265A2.414 2.414 0 0 1 23 6.995v9.228a2.414 2.414 0 0 1-2.414 2.414h-1.435l-1.394 3.068c-.347.75-1.353.894-1.878.257l-1.585-1.905H10.79a2.414 2.414 0 0 1-2.376-1.988H15.19a3.833 3.833 0 0 0 3.834-3.833V4.582H17.32v9.083a2.414 2.414 0 0 1-2.414 2.414h-6.06l.002.002h-.472v1.59-1.592H8.28l-.686.826-.615.738a1.124 1.124 0 0 1-1.878-.257L3.604 14.09h-.339A3.265 3.265 0 0 1 0 10.826V3.3A3.265 3.265 0 0 1 3.265.035H7.83a9.06 9.06 0 0 1 1.607 0h4.619Zm-2.875 8.63H5.59a.845.845 0 0 1-.84-.839c0-.458.38-.838.84-.838h5.59c.458 0 .838.38.838.838 0 .459-.38.839-.838.839Z'
                clipRule='evenodd'
            />
        </svg>
    );
};

export const ProjectTopicMessageUnreadIcon: React.FC<NotificationIconProps> = ({
    numberOfUnreadNotifications,
}) => {
    // Calculate different X positions for one digit and two digit numbers
    // 1 digit -> x=46
    // 2 digit -> x=43
    const unreadMessageCounterXPos = numberOfUnreadNotifications < 10 ? 23 : 21;
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='33'
            height='29'
            fill='none'
        >
            <path
                fill='#fff'
                fillRule='evenodd'
                d='M15.37 4.189a3.546 3.546 0 0 1 3.546 3.545v1.391h3.546a2.62 2.62 0 0 1 2.62 2.62v10.02a2.62 2.62 0 0 1-2.62 2.622h-1.559l-1.513 3.33c-.376.814-1.469.972-2.04.28l-1.72-2.069h-3.805a2.621 2.621 0 0 1-2.58-2.16h4.006l.116.002h3.237a4.162 4.162 0 0 0 4.162-4.162V9.125h-1.85v9.862a2.62 2.62 0 0 1-2.62 2.621h-6.58l.001.002h-.512v1.71-1.712h-.106l-.745.897-.667.802a1.22 1.22 0 0 1-2.04-.28L4.022 19.45h-.368A3.546 3.546 0 0 1 .11 15.904v-8.17A3.545 3.545 0 0 1 3.654 4.19h4.957a9.834 9.834 0 0 1 1.744 0h5.015Zm-3.121 9.37h-6.07a.917.917 0 0 1-.91-.911c0-.498.412-.91.91-.91h6.07c.497 0 .91.412.91.91 0 .498-.413.91-.91.91Z'
                clipRule='evenodd'
            />
            <path
                fill='#EB4E43'
                d='M20.109 2.056a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7Z'
            />
            <text fill='white' fontSize='9' letterSpacing='-0.09em'>
                <tspan x={unreadMessageCounterXPos} y='9'>
                    {numberOfUnreadNotifications.toString()}
                </tspan>
            </text>
        </svg>
    );
};

export const ProjectTopicEditParticipantsSelectedIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='19'
            fill='none'
        >
            <path
                fill='#79A342'
                d='M16.375.902h-14a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2Z'
            />
            <path
                fill='#fff'
                d='m8.356 11.996 6.048-6.05.931.931-6.98 6.98-4.187-4.188.93-.93 3.258 3.257Z'
            />
        </svg>
    );
};

export const ProjectTopicEditParticipantsUnselectedIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='19'
            fill='none'
        >
            <path
                fill='#95AAC9'
                d='M16.125 2.385v14h-14v-14h14Zm0-2h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Z'
            />
        </svg>
    );
};

export const GreenCheckmarkIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='13'
            fill='none'
        >
            <path
                fill='#79A342'
                stroke='#79A342'
                d='M6.834 9.427 15.261 1l1.297 1.296-9.724 9.724L1 6.186 2.296 4.89l4.538 4.537Z'
            />
        </svg>
    );
};

export const CircleWithArrow = () => {
    return (
        <svg
            width='21'
            height='21'
            viewBox='0 0 16 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 8.52478C0 4.10878 3.584 0.52478 8 0.52478C12.416 0.52478 16 4.10878 16 8.52478C16 12.9408 12.416 16.5248 8 16.5248C3.584 16.5248 0 12.9408 0 8.52478ZM1.64193 9.25934C2.00761 12.4429 4.72036 14.9248 8 14.9248C11.528 14.9248 14.4 12.0528 14.4 8.52478C14.4 4.99678 11.528 2.12478 8 2.12478C4.66827 2.12478 1.92158 4.68612 1.62628 7.94244H9.33563L7.5015 6.23059L8.48911 5.30884L12.0163 8.60089L8.48911 11.8929L7.5015 10.9712L9.33563 9.25934H1.64193Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const RightGrayArrowIcon = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.05671 0.410563L15.9932 7.51321C16.0914 7.54635 16.1773 7.60835 16.2397 7.69107C16.3021 7.7738 16.3382 7.87339 16.3431 7.97679C16.3479 8.0802 16.3215 8.18258 16.2671 8.27053C16.2128 8.35848 16.1331 8.42788 16.0385 8.46964L1.08064 15.6125C0.98898 15.6537 0.887168 15.6671 0.787837 15.6509C0.688507 15.6348 0.596029 15.5898 0.521889 15.5216C0.447748 15.4535 0.395207 15.3651 0.370786 15.2674C0.346366 15.1698 0.351143 15.0672 0.384525 14.9724L2.27313 9.53171L9.83049 8.02433L2.28916 6.49455L0.364274 1.04891C0.330958 0.954237 0.326061 0.851959 0.350185 0.754691C0.37431 0.657423 0.426402 0.569419 0.500034 0.50154C0.573665 0.43366 0.665615 0.388874 0.764537 0.372708C0.86346 0.356541 0.965027 0.369701 1.05671 0.410563Z'
                fill='#6E84A3'
            />
        </svg>
    );
};

export const DashboardDataCardsArrowIcon = () => {
    return (
        <svg
            width='17'
            height='12'
            viewBox='0 0 17 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.8209 6.88291L10.1515 6.88291V9.76868C10.1515 10.9121 11.54 11.4838 12.3476 10.6762L16.5039 6.51992C17.003 6.02081 17.003 5.20408 16.5039 4.70497L12.3295 0.530574C11.5218 -0.277079 10.1334 0.294631 10.1334 1.43805V4.32383L1.80275 4.32383C1.09492 4.32383 0.52321 4.89554 0.523209 5.60337C0.541359 6.3112 1.11307 6.88291 1.8209 6.88291Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const BadgeStatusIcon = (className: string) => {
    return (
        <svg
            className={className}
            id='status-badge-icon'
            xmlns='http://www.w3.org/2000/svg'
            width='8'
            height='8'
            fill='none'
        >
            <path d='M4.007 0a3.992 3.992 0 0 1 2.015.55 3.935 3.935 0 0 1 1.44 1.438A3.978 3.978 0 0 1 8.015 4c0 .365-.048.717-.144 1.059a4.07 4.07 0 0 1-1.037 1.765 4.023 4.023 0 0 1-1.765 1.031c-.34.097-.693.145-1.06.145a3.89 3.89 0 0 1-1.061-.145 4.085 4.085 0 0 1-1.77-1.03A4.117 4.117 0 0 1 .146 5.058 3.87 3.87 0 0 1 0 4c0-.367.048-.72.145-1.059A4.07 4.07 0 0 1 1.178 1.18 4.045 4.045 0 0 1 2.947.145 3.89 3.89 0 0 1 4.007 0Z' />
        </svg>
    );
};

export const TableNDAIndicatorCross = () => {
    return (
        <svg
            width='9'
            height='9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='table-nda-indicator-cross'
        >
            <path
                d='M9 .906 8.094 0 4.5 3.594.906 0 0 .906 3.594 4.5 0 8.094.906 9 4.5 5.406 8.094 9 9 8.094 5.406 4.5 9 .906Z'
                fill='#35336C'
            />
        </svg>
    );
};

export const TableNDAIndicatorCheckmark = () => {
    return (
        <svg
            width='12'
            height='9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid='table-nda-indicator-checkmark'
        >
            <path
                d='M3.575 7.1.908 4.303 0 5.248 3.575 9 11.25.946 10.348 0 3.575 7.1Z'
                fill='#79A342'
            />
        </svg>
    );
};

export const SearchFilter = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='10'
            fill='none'
        >
            <path
                fill='#1C437A'
                d='M.873 1.218V.14L.898.138h13.909v1.08H.872ZM12.745 4.46h-9.46v1.08h9.46V4.46ZM5.876 9.862v-1.08h4.377v1.08H5.876Z'
            />
        </svg>
    );
};

export const GermanFlag = () => {
    return (
        <svg
            width='18'
            height='13'
            viewBox='0 0 18 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='0.112793'
                y='0.81311'
                width='17'
                height='12'
                rx='2'
                fill='white'
            />
            <mask
                id='mask0_820_32932'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='18'
                height='13'
            >
                <rect
                    x='0.112793'
                    y='0.81311'
                    width='17'
                    height='12'
                    rx='2'
                    fill='white'
                />
            </mask>
            <g mask='url(#mask0_820_32932)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.112793 4.81311H17.1128V0.81311H0.112793V4.81311Z'
                    fill='#262626'
                />
                <g filter='url(#filter0_d_820_32932)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M0.112793 8.81311H17.1128V4.81311H0.112793V8.81311Z'
                        fill='#F01515'
                    />
                </g>
                <g filter='url(#filter1_d_820_32932)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M0.112793 12.8131H17.1128V8.81311H0.112793V12.8131Z'
                        fill='#FFD521'
                    />
                </g>
            </g>
            <defs>
                <filter
                    id='filter0_d_820_32932'
                    x='0.112793'
                    y='4.81311'
                    width='17'
                    height='4'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_820_32932'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_820_32932'
                        result='shape'
                    />
                </filter>
                <filter
                    id='filter1_d_820_32932'
                    x='0.112793'
                    y='8.81311'
                    width='17'
                    height='4'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_820_32932'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_820_32932'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const EnglishFlag = () => {
    return (
        <svg
            data-testid={'english-flag'}
            width='18'
            height='13'
            viewBox='0 0 18 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='0.112793'
                y='0.81311'
                width='17.1429'
                height='12'
                rx='2'
                fill='white'
            />
            <mask
                id='mask0_820_32933'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='18'
                height='13'
            >
                <rect
                    x='0.112793'
                    y='0.81311'
                    width='17.1429'
                    height='12'
                    rx='2'
                    fill='white'
                />
            </mask>
            <g mask='url(#mask0_820_32933)'>
                <rect
                    x='0.112793'
                    y='0.81311'
                    width='17.1429'
                    height='12'
                    fill='#0A17A7'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M-0.672481 -0.336792L6.64332 4.49909V0.0130128H10.7249V4.49908L18.0407 -0.336792L18.9537 0.989668L13.1697 4.81301H17.2556V8.81301H13.1695L18.9537 12.6365L18.0407 13.9629L10.7249 9.12707V13.613H6.64332V9.12707L-0.672481 13.9629L-1.58545 12.6365L4.19876 8.81301H0.112705V4.81301H4.19857L-1.58545 0.989668L-0.672481 -0.336792Z'
                    fill='white'
                />
                <path
                    d='M11.542 4.61248L19.2963 -0.386841'
                    stroke='#DB1F35'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                />
                <path
                    d='M12.3657 9.03159L19.3171 13.6233'
                    stroke='#DB1F35'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                />
                <path
                    d='M5.01401 4.59941L-2.23682 -0.189453'
                    stroke='#DB1F35'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                />
                <path
                    d='M5.80044 8.976L-2.23682 14.1993'
                    stroke='#DB1F35'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.112793 8.01311H7.45973V12.8131H9.90871V8.01311H17.2556V5.61311H9.90871V0.81311H7.45973V5.61311H0.112793V8.01311Z'
                    fill='#E6273E'
                />
            </g>
        </svg>
    );
};

export const KebabMenuVerticalDots = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='4'
            height='16'
            fill='none'
        >
            <path
                fill='#95AAC9'
                d='M.87 2.316c0-.402.144-.748.432-1.037A1.415 1.415 0 0 1 2.34.846c.403 0 .75.145 1.038.433.288.289.433.635.433 1.037 0 .403-.145.75-.433 1.038a1.415 1.415 0 0 1-1.038.433c-.266 0-.511-.068-.735-.205a1.525 1.525 0 0 1-.539-.53 1.4 1.4 0 0 1-.196-.736Zm0 5.874c0-.402.144-.748.432-1.037A1.415 1.415 0 0 1 2.34 6.72c.403 0 .75.145 1.038.433.288.289.433.635.433 1.037 0 .403-.145.75-.433 1.038a1.415 1.415 0 0 1-1.038.433c-.266 0-.511-.068-.735-.205a1.525 1.525 0 0 1-.539-.53A1.4 1.4 0 0 1 .87 8.19Zm0 5.875c0-.403.144-.75.432-1.038a1.415 1.415 0 0 1 1.037-.433c.403 0 .75.145 1.038.433.288.289.433.635.433 1.038 0 .402-.145.748-.433 1.037a1.415 1.415 0 0 1-1.038.433c-.266 0-.511-.068-.735-.205a1.524 1.524 0 0 1-.539-.53 1.4 1.4 0 0 1-.196-.736Z'
            />
        </svg>
    );
};

export const DuplicateIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='13'
            height='16'
            fill='none'
        >
            <path
                fill='#1F2756'
                d='M3.458 15.384h8.12c.745 0 1.354-.613 1.354-1.363V4.475h-1.354v9.546h-8.12v1.363Zm-2.03-2.727H8.87c.745 0 1.354-.614 1.354-1.364V1.748c0-.75-.61-1.364-1.354-1.364H1.428C.684.384.074.998.074 1.748v9.545c0 .75.61 1.364 1.354 1.364Zm0-10.909H8.87v9.545H1.428V1.748Z'
            />
        </svg>
    );
};

export const FileUploadDropzoneIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='28'
            fill='none'
        >
            <path
                fill='#1F2756'
                fillRule='evenodd'
                d='M2.094 2.102v22.95h10.173a1 1 0 0 1 0 2H1.594a1.5 1.5 0 0 1-1.5-1.5V1.601a1.5 1.5 0 0 1 1.5-1.5h11.32a1.5 1.5 0 0 1 1.08.459L19.723 6.5c.27.28.42.653.42 1.041v3.025h-2v-.72h-4.735a3 3 0 0 1-3-3V2.101H2.094Zm16.05 5.641v.102h-4.736a1 1 0 0 1-1-1V2.102h.294l5.441 5.641Zm.746 17.758a1 1 0 0 1-1-1v-2.898h-2.898a1 1 0 1 1 0-2h2.898v-2.898a1 1 0 0 1 2 0v2.898h2.898a1 1 0 1 1 0 2H19.89v2.898a1 1 0 0 1-1 1Z'
                clipRule='evenodd'
            />
            <path
                fill='#1F2756'
                d='M.094 2.075h1.422V.102H.094zM.094 27.052H13.59v-2.017H.094zM10.4 9.826h1.422V6.572H10.4z'
            />
            <path fill='#1F2756' d='M10.4 9.92h8.25V8.482H10.4z' />
            <path fill='#F9FAFC' d='M12.431 7.84h3.672V6.402h-3.672z' />
        </svg>
    );
};

export const RemoveUploadedFileIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='13'
            height='13'
            fill='none'
        >
            <path
                fill='#35336C'
                d='m11.24 12.188 1.17-1.17-4.641-4.641 4.64-4.641-1.17-1.17-4.64 4.64L1.956.566l-1.17 1.17 4.64 4.64-4.64 4.641 1.17 1.171 4.641-4.64 4.641 4.64Z'
            />
        </svg>
    );
};

export const DownloadUploadedFileIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='11'
            height='17'
            fill='none'
        >
            <path
                fill='#35336C'
                d='M4.651 10.32V.78H6.22v9.54L9.29 7.252l1.106 1.106-4.962 4.962L.371 8.257l1.109-1.11L4.65 10.32Z'
            />
            <path
                fill='#35336C'
                fillRule='evenodd'
                d='M10.829 14.475H.75v1.567h9.539l.54-.14v-1.427Z'
                clipRule='evenodd'
            />
        </svg>
    );
};

export const renderExpandCollapseIcon = (isExpanded: boolean) => {
    return (
        <div className={'expand-collapse-scale'}>
            <div
                className={`${
                    isExpanded
                        ? 'expand-collapse-icon-expanded'
                        : 'expand-collapse-icon-not-expanded'
                }`}
            >
                <GradingArrowDown />
            </div>
            <div
                className={`${
                    isExpanded
                        ? 'expand-collapse-icon-not-expanded'
                        : 'expand-collapse-icon-expanded'
                }`}
            >
                <GradingArrowDown />
            </div>
        </div>
    );
};

export const SlideoutBackButton = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='14'
            fill='none'
        >
            <path
                fill='#1F2756'
                d='m7.101.721 1.154 1.166L3.688 6.51h15.488v1.654H3.687l4.569 4.622L7.1 13.951.551 7.336 7.1.721Z'
            />
        </svg>
    );
};

export const SlideoutCloseIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='13'
            height='13'
            fill='none'
        >
            <path
                fill='#fff'
                d='M12.72 2.021 11.51.813l-4.79 4.79L1.927.814.719 2.02l4.792 4.792-4.792 4.79 1.209 1.21L6.719 8.02l4.792 4.791 1.208-1.208-4.791-4.791 4.791-4.792Z'
            />
        </svg>
    );
};

export const FilterIcon = () => {
    return (
        <svg
            width='11'
            height='12'
            viewBox='0 0 11 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.60695 7.1203V6.87599L4.44602 6.69216L1.0875 2.85572V1.55932L9.47081 1.55874V2.85609L6.13047 6.69354L5.97075 6.87703V7.1203V10.4687H4.60695V7.1203Z'
                stroke='#1F2756'
                strokeWidth='1.3'
            />
        </svg>
    );
};

export const ExportToExcelIcon = () => {
    return (
        <svg
            width='16'
            height='15'
            viewBox='0 0 16 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.05959 1.72744C1.12442 1.65241 1.21427 1.60345 1.31247 1.58965L11.742 0.110645C11.8001 0.10226 11.8593 0.106462 11.9156 0.122965C11.9719 0.139467 12.0241 0.167886 12.0684 0.206294C12.1128 0.244703 12.1484 0.292204 12.1728 0.345577C12.1973 0.398951 12.2099 0.456951 12.21 0.515646V13.8926C12.2101 13.9513 12.1976 14.0093 12.1734 14.0628C12.1492 14.1162 12.1137 14.1638 12.0695 14.2024C12.0253 14.2409 11.9733 14.2695 11.917 14.2862C11.8608 14.3029 11.8016 14.3073 11.7435 14.2991L1.31397 12.8561C1.10997 12.8291 0.959968 12.6551 0.959968 12.4511V1.99765C0.959367 1.89849 0.994766 1.80248 1.05959 1.72744ZM4.7591 4.71754C4.7049 4.62712 4.60721 4.57179 4.50179 4.57179H3.78351C3.54549 4.57179 3.40226 4.83569 3.53197 5.03527L5.19743 7.59784C5.26238 7.69778 5.26201 7.82669 5.19648 7.92626L3.51039 10.488C3.3791 10.6875 3.52218 10.9529 3.76099 10.9529H4.48058C4.58321 10.9529 4.67871 10.9005 4.73376 10.8139L5.90822 8.96607C6.02599 8.78079 6.29636 8.78061 6.41438 8.96574L7.59266 10.8142C7.64775 10.9006 7.74314 10.9529 7.84563 10.9529H8.55788C8.79734 10.9529 8.94029 10.6862 8.80768 10.4868L7.10578 7.9278C7.03908 7.82751 7.03883 7.69704 7.10515 7.5965L8.79331 5.03696C8.92486 4.8375 8.78181 4.57179 8.54287 4.57179H7.83269C7.72768 4.57179 7.63032 4.62669 7.57598 4.71653L6.41887 6.62979C6.30188 6.82322 6.0211 6.82268 5.90486 6.62879L4.7591 4.71754Z'
                fill='white'
            />
            <path
                d='M13.1475 11.8901V2.51515L15.4905 2.51665C15.5522 2.51645 15.6133 2.52846 15.6704 2.55198C15.7274 2.57551 15.7793 2.61008 15.8229 2.65372C15.8665 2.69735 15.9011 2.74919 15.9246 2.80624C15.9482 2.86329 15.9602 2.92443 15.96 2.98615V11.4206C15.96 11.6801 15.75 11.8901 15.492 11.8901H13.1475Z'
                fill='white'
            />
        </svg>
    );
};

export const MultiSelectorPlusIcon = () => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid={'multi-selector-plus-icon'}
        >
            <path
                d='M16.0061 8.54687L16.0061 6.85208L9.28709 6.85208V0.133037H7.5923V6.85208L0.873261 6.85208L0.873261 8.54687H7.5923L7.5923 15.2659H9.28709L9.28709 8.54687H16.0061Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const MultiSelectorMinusIcon = () => {
    return (
        <svg
            width='17'
            height='3'
            viewBox='0 0 17 3'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            data-testid={'multi-selector-minus-icon'}
        >
            <path
                d='M16.0061 2.12499L16.0061 0.430206L9.28709 0.430206H7.5923L0.873261 0.430206L0.873261 2.12499H7.5923H9.28709H16.0061Z'
                fill='#95AAC9'
            />
        </svg>
    );
};

export const KeywordsIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.28901 4.2587H8.25259L11.3039 11.325H9.95492L9.37677 9.91172H6.16483L5.58668 11.325H4.23766L7.28901 4.2587ZM7.7708 5.53063L6.56953 8.75542H8.97207L7.7708 5.53063Z'
                fill='#B1B3C9'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M0 8.3078C0 4.05109 3.45472 0.596375 7.71143 0.596375C11.9681 0.596375 15.4229 4.05109 15.4229 8.3078C15.4229 12.5645 11.9681 16.0192 7.71143 16.0192C3.45472 16.0192 0 12.5645 0 8.3078ZM1.54229 8.3078C1.54229 11.7085 4.31069 14.4769 7.71143 14.4769C11.1122 14.4769 13.8806 11.7085 13.8806 8.3078C13.8806 4.90706 11.1122 2.13866 7.71143 2.13866C4.31069 2.13866 1.54229 4.90706 1.54229 8.3078Z'
                fill='#B1B3C9'
            />
        </svg>
    );
};

export const FormatIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.0378 0.107483H1.68237C0.832935 0.107483 0.137939 0.802478 0.137939 1.65192V12.463C0.137939 13.3124 0.832935 14.0074 1.68237 14.0074H13.0378C13.8873 14.0074 14.5823 13.3124 14.5823 12.463V1.65192C14.5823 0.802478 13.8873 0.107483 13.0378 0.107483ZM13.0378 12.463H1.68237V1.65192H13.0378V12.463Z'
                fill='#B1B3C9'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.5822 5.83738L11.4857 4.74083L9.03776 7.18876L7.94893 6.09221L6.86011 7.18103L9.03776 9.37413L12.5822 5.83738Z'
                fill='#B1B3C9'
            />
            <path
                d='M5.31567 3.19638H2.45459V4.74081H5.31567V3.19638Z'
                fill='#B1B3C9'
            />
            <path
                d='M5.31567 6.28528H2.45459V7.82971H5.31567V6.28528Z'
                fill='#B1B3C9'
            />
            <path
                d='M5.31567 9.37404H2.45459V10.9185H5.31567V9.37404Z'
                fill='#B1B3C9'
            />
        </svg>
    );
};

export const OverviewIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.962 0.302673H1.62025C0.721012 0.302673 0 1.06824 0 2.00394V12.2114C0 13.1471 0.721012 13.9127 1.62025 13.9127H12.962C13.8532 13.9127 14.5823 13.1471 14.5823 12.2114V2.00394C14.5823 1.06824 13.8613 0.302673 12.962 0.302673ZM13.151 12.464H1.44356V1.75333H13.151V12.464ZM7.29113 4.98103C8.78176 4.98103 10.1104 5.79764 10.8071 7.10761C10.1104 8.41759 8.78176 9.2342 7.29113 9.2342C5.8005 9.2342 4.47189 8.41759 3.77519 7.10761C4.47189 5.79764 5.8005 4.98103 7.29113 4.98103ZM7.29113 3.70509C5.07949 3.70509 3.1919 5.11714 2.43038 7.10761C3.1919 9.09809 5.07949 10.5101 7.29113 10.5101C9.50278 10.5101 11.3904 9.09809 12.1519 7.10761C11.3904 5.11714 9.50278 3.70509 7.29113 3.70509ZM7.29113 8.38356C6.61873 8.38356 6.07594 7.81364 6.07594 7.10761C6.07594 6.40159 6.61873 5.83167 7.29113 5.83167C7.96354 5.83167 8.50632 6.40159 8.50632 7.10761C8.50632 7.81364 7.96354 8.38356 7.29113 8.38356Z'
                fill='#B1B3C9'
            />
        </svg>
    );
};
